var items = {
  "block.minecraft.acacia_button": "nena ilo pi kasi seli",
  "block.minecraft.acacia_door": "lupa pi kasi seli",
  "block.minecraft.acacia_fence": "sinpin palisa pi kasi seli",
  "block.minecraft.acacia_fence_gate": "sinpin tawa pi kasi seli",
  "block.minecraft.acacia_hanging_sign": "lipu sitelen sewi pi kasi seli",
  "block.minecraft.acacia_leaves": "lipu pi kasi seli",
  "block.minecraft.acacia_log": "sijelo pi kasi seli",
  "block.minecraft.acacia_planks": "kiwen kipisi pi kasi seli",
  "block.minecraft.acacia_pressure_plate": "supa noka pi kasi seli",
  "block.minecraft.acacia_sapling": "kasi seli sin",
  "block.minecraft.acacia_shelf": "poki sinpin pi kasi seli",
  "block.minecraft.acacia_sign": "lipu sitelen pi kasi seli",
  "block.minecraft.acacia_slab": "supa pi kasi seli",
  "block.minecraft.acacia_stairs": "leko sewi pi kasi seli",
  "block.minecraft.acacia_trapdoor": "lupa anpa pi kasi seli",
  "block.minecraft.acacia_wall_hanging_sign": "lipu sitelen sewi pi kasi loje jelo lon sinpin",
  "block.minecraft.acacia_wall_sign": "lipu sitelen kasi pi loje jelo lon sinpin",
  "block.minecraft.acacia_wood": "kiwen pi kasi seli",
  "block.minecraft.activator_rail": "nasin palisa weka",
  "block.minecraft.air": "kon",
  "block.minecraft.allium": "kasi pi laso loje",
  "block.minecraft.amethyst_block": "kiwen kalama",
  "block.minecraft.amethyst_cluster": "kulupu pi kiwen kalama",
  "block.minecraft.ancient_debris": "pakala mani",
  "block.minecraft.andesite": "kiwen pimeja walo",
  "block.minecraft.andesite_slab": "supa pi kiwen pimeja walo",
  "block.minecraft.andesite_stairs": "leko sewi pi kiwen pimeja walo",
  "block.minecraft.andesite_wall": "sinpin pi kiwen pimeja walo",
  "block.minecraft.anvil": "supa pona",
  "block.minecraft.attached_melon_stem": "kasi lon kili suli laso",
  "block.minecraft.attached_pumpkin_stem": "kasi pi kili suli lon kili",
  "block.minecraft.azalea": "kasi lupa",
  "block.minecraft.azalea_leaves": "lipu pi kasi kiwen lupa",
  "block.minecraft.azure_bluet": "kasi walo lili",
  "block.minecraft.bamboo": "kasi palisa",
  "block.minecraft.bamboo_block": "leko pi kasi palisa",
  "block.minecraft.bamboo_button": "nena ilo pi kasi palisa",
  "block.minecraft.bamboo_door": "lupa pi kasi palisa",
  "block.minecraft.bamboo_fence": "sinpin palisa pi kasi palisa",
  "block.minecraft.bamboo_fence_gate": "sinpin tawa pi kasi palisa",
  "block.minecraft.bamboo_hanging_sign": "lipu sitelen sewi pi kasi palisa",
  "block.minecraft.bamboo_mosaic": "kiwen kipisi namako pi kasi palisa",
  "block.minecraft.bamboo_mosaic_slab": "supa namako pi kasi palisa",
  "block.minecraft.bamboo_mosaic_stairs": "leko sewi namako pi kasi palisa",
  "block.minecraft.bamboo_planks": "kiwen kipisi pi kasi palisa",
  "block.minecraft.bamboo_pressure_plate": "supa noka pi kasi palisa",
  "block.minecraft.bamboo_sapling": "kasi palisa sin",
  "block.minecraft.bamboo_shelf": "poki sinpin pi kasi palisa",
  "block.minecraft.bamboo_sign": "lipu sitelen pi kasi palisa",
  "block.minecraft.bamboo_slab": "supa pi kasi palisa",
  "block.minecraft.bamboo_stairs": "leko sewi pi kasi palisa",
  "block.minecraft.bamboo_trapdoor": "lupa anpa pi kasi palisa",
  "block.minecraft.bamboo_wall_hanging_sign": "lipu sitelen sewi pi kasi palisa lon sinpin",
  "block.minecraft.bamboo_wall_sign": "lipu sitelen pi kasi palisa lon sinpin",
  "block.minecraft.banner.base.black": "ale pimeja",
  "block.minecraft.banner.base.blue": "ale pi laso telo",
  "block.minecraft.banner.base.brown": "ale pi loje ma",
  "block.minecraft.banner.base.cyan": "ale laso",
  "block.minecraft.banner.base.gray": "ale pi pimeja walo",
  "block.minecraft.banner.base.green": "ale pi laso kasi",
  "block.minecraft.banner.base.light_blue": "ale pi laso sewi",
  "block.minecraft.banner.base.light_gray": "ale pi walo pimeja",
  "block.minecraft.banner.base.lime": "ale pi laso jelo",
  "block.minecraft.banner.base.magenta": "ale pi loje laso",
  "block.minecraft.banner.base.orange": "ale pi loje jelo",
  "block.minecraft.banner.base.pink": "ale pi loje walo",
  "block.minecraft.banner.base.purple": "ale pi laso loje",
  "block.minecraft.banner.base.red": "ale loje",
  "block.minecraft.banner.base.white": "ale walo",
  "block.minecraft.banner.base.yellow": "ale jelo",
  "block.minecraft.banner.border.black": "selo pimeja",
  "block.minecraft.banner.border.blue": "selo pi laso telo",
  "block.minecraft.banner.border.brown": "selo pi loje ma",
  "block.minecraft.banner.border.cyan": "selo laso",
  "block.minecraft.banner.border.gray": "selo pi pimeja walo",
  "block.minecraft.banner.border.green": "selo pi laso kasi",
  "block.minecraft.banner.border.light_blue": "selo pi laso sewi",
  "block.minecraft.banner.border.light_gray": "selo pi walo pimeja",
  "block.minecraft.banner.border.lime": "selo pi laso jelo",
  "block.minecraft.banner.border.magenta": "selo pi loje laso",
  "block.minecraft.banner.border.orange": "selo pi loje jelo",
  "block.minecraft.banner.border.pink": "selo pi loje walo",
  "block.minecraft.banner.border.purple": "selo pi laso loje",
  "block.minecraft.banner.border.red": "selo loje",
  "block.minecraft.banner.border.white": "selo walo",
  "block.minecraft.banner.border.yellow": "selo jelo",
  "block.minecraft.banner.bricks.black": "leko lili pimeja",
  "block.minecraft.banner.bricks.blue": "leko lili pi laso telo",
  "block.minecraft.banner.bricks.brown": "leko lili pi loje ma",
  "block.minecraft.banner.bricks.cyan": "leko lili laso",
  "block.minecraft.banner.bricks.gray": "leko lili pi pimeja walo",
  "block.minecraft.banner.bricks.green": "leko lili pi laso kasi",
  "block.minecraft.banner.bricks.light_blue": "leko lili pi laso sewi",
  "block.minecraft.banner.bricks.light_gray": "leko lili pi walo pimeja",
  "block.minecraft.banner.bricks.lime": "leko lili pi laso jelo",
  "block.minecraft.banner.bricks.magenta": "leko lili pi loje laso",
  "block.minecraft.banner.bricks.orange": "leko lili pi loje jelo",
  "block.minecraft.banner.bricks.pink": "leko lili pi loje walo",
  "block.minecraft.banner.bricks.purple": "leko lili pi laso loje",
  "block.minecraft.banner.bricks.red": "leko lili loje",
  "block.minecraft.banner.bricks.white": "leko lili walo",
  "block.minecraft.banner.bricks.yellow": "leko lili jelo",
  "block.minecraft.banner.circle.black": "sike pimeja",
  "block.minecraft.banner.circle.blue": "sike pi laso telo",
  "block.minecraft.banner.circle.brown": "sike pi loje ma",
  "block.minecraft.banner.circle.cyan": "sike laso",
  "block.minecraft.banner.circle.gray": "sike pi pimeja walo",
  "block.minecraft.banner.circle.green": "sike pi laso kasi",
  "block.minecraft.banner.circle.light_blue": "sike pi laso sewi",
  "block.minecraft.banner.circle.light_gray": "sike pi walo pimeja",
  "block.minecraft.banner.circle.lime": "sike pi laso jelo",
  "block.minecraft.banner.circle.magenta": "sike pi loje laso",
  "block.minecraft.banner.circle.orange": "sike pi loje jelo",
  "block.minecraft.banner.circle.pink": "sike pi loje walo",
  "block.minecraft.banner.circle.purple": "sike pi laso loje",
  "block.minecraft.banner.circle.red": "sike loje",
  "block.minecraft.banner.circle.white": "sike walo",
  "block.minecraft.banner.circle.yellow": "sike jelo",
  "block.minecraft.banner.creeper.black": "monsuta Creeper pimeja",
  "block.minecraft.banner.creeper.blue": "monsuta Creeper pi laso telo",
  "block.minecraft.banner.creeper.brown": "monsuta Creeper pi loje ma",
  "block.minecraft.banner.creeper.cyan": "monsuta Creeper laso",
  "block.minecraft.banner.creeper.gray": "monsuta Creeper pi pimeja walo",
  "block.minecraft.banner.creeper.green": "monsuta Creeper pi laso kasi",
  "block.minecraft.banner.creeper.light_blue": "monsuta Creeper pi laso sewi",
  "block.minecraft.banner.creeper.light_gray": "monsuta Creeper pi walo pimeja",
  "block.minecraft.banner.creeper.lime": "monsuta Creeper pi laso jelo",
  "block.minecraft.banner.creeper.magenta": "monsuta Creeper pi loje laso",
  "block.minecraft.banner.creeper.orange": "monsuta Creeper pi loje jelo",
  "block.minecraft.banner.creeper.pink": "monsuta Creeper pi loje walo",
  "block.minecraft.banner.creeper.purple": "monsuta Creeper pi laso loje",
  "block.minecraft.banner.creeper.red": "monsuta Creeper loje",
  "block.minecraft.banner.creeper.white": "monsuta Creeper walo",
  "block.minecraft.banner.creeper.yellow": "monsuta Creeper jelo",
  "block.minecraft.banner.cross.black": "sitelen 'x' pimeja",
  "block.minecraft.banner.cross.blue": "sitelen 'x' pi laso telo",
  "block.minecraft.banner.cross.brown": "sitelen 'x' pi loje ma",
  "block.minecraft.banner.cross.cyan": "sitelen 'x' laso",
  "block.minecraft.banner.cross.gray": "sitelen 'x' pi pimeja walo",
  "block.minecraft.banner.cross.green": "sitelen 'x' pi laso kasi",
  "block.minecraft.banner.cross.light_blue": "sitelen 'x' pi laso sewi",
  "block.minecraft.banner.cross.light_gray": "sitelen 'x' pi walo pimeja",
  "block.minecraft.banner.cross.lime": "sitelen 'x' pi laso jelo",
  "block.minecraft.banner.cross.magenta": "sitelen 'x' pi loje laso",
  "block.minecraft.banner.cross.orange": "sitelen 'x' pi loje jelo",
  "block.minecraft.banner.cross.pink": "sitelen 'x' pi loje walo",
  "block.minecraft.banner.cross.purple": "sitelen 'x' pi laso loje",
  "block.minecraft.banner.cross.red": "sitelen 'x' loje",
  "block.minecraft.banner.cross.white": "sitelen 'x' walo",
  "block.minecraft.banner.cross.yellow": "sitelen 'x' jelo",
  "block.minecraft.banner.curly_border.black": "selo nena pimeja",
  "block.minecraft.banner.curly_border.blue": "selo nena pi laso telo",
  "block.minecraft.banner.curly_border.brown": "selo nena pi loje ma",
  "block.minecraft.banner.curly_border.cyan": "selo nena laso",
  "block.minecraft.banner.curly_border.gray": "selo nena pi pimeja walo",
  "block.minecraft.banner.curly_border.green": "selo nena pi laso kasi",
  "block.minecraft.banner.curly_border.light_blue": "selo nena pi laso sewi",
  "block.minecraft.banner.curly_border.light_gray": "selo nena pi walo pimeja",
  "block.minecraft.banner.curly_border.lime": "selo nena pi laso jelo",
  "block.minecraft.banner.curly_border.magenta": "selo nena pi loje laso",
  "block.minecraft.banner.curly_border.orange": "selo nena pi loje jelo",
  "block.minecraft.banner.curly_border.pink": "selo nena pi loje walo",
  "block.minecraft.banner.curly_border.purple": "selo nena pi laso loje",
  "block.minecraft.banner.curly_border.red": "selo nena loje",
  "block.minecraft.banner.curly_border.white": "selo nena walo",
  "block.minecraft.banner.curly_border.yellow": "selo nena jelo",
  "block.minecraft.banner.diagonal_left.black": "kipisi pimeja lon poka open sewi",
  "block.minecraft.banner.diagonal_left.blue": "kipisi pi laso telo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.brown": "kipisi pi loje ma lon poka open sewi",
  "block.minecraft.banner.diagonal_left.cyan": "kipisi laso lon poka open sewi",
  "block.minecraft.banner.diagonal_left.gray": "kipisi pi pimeja walo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.green": "kipisi pi laso kasi lon poka open sewi",
  "block.minecraft.banner.diagonal_left.light_blue": "kipisi pi laso sewi lon poka open sewi",
  "block.minecraft.banner.diagonal_left.light_gray": "kipisi pi walo pimeja lon poka open sewi",
  "block.minecraft.banner.diagonal_left.lime": "kipisi pi laso jelo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.magenta": "kipisi pi loje laso lon poka open sewi",
  "block.minecraft.banner.diagonal_left.orange": "kipisi pi loje jelo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.pink": "kipisi pi loje walo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.purple": "kipisi pi laso loje lon poka open sewi",
  "block.minecraft.banner.diagonal_left.red": "kipisi loje lon poka open sewi",
  "block.minecraft.banner.diagonal_left.white": "kipisi walo lon poka open sewi",
  "block.minecraft.banner.diagonal_left.yellow": "kipisi jelo lon poka open sewi",
  "block.minecraft.banner.diagonal_right.black": "kipisi pimeja lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.blue": "kipisi pi laso telo lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.brown": "kipisi pi loje ma lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.cyan": "kipisi laso lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.gray": "kipisi pi pimeja walo lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.green": "kipisi pi laso kasi lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.light_blue": "kipisi pi laso sewi lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.light_gray": "kipisi pi walo pimeja lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.lime": "kipisi laso lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.magenta": "kipisi pi loje laso lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.orange": "kipisi pi loje jelo lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.pink": "kipisi pi loje walo lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.purple": "kipisi pi laso loje lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.red": "kipisi loje lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.white": "kipisi walo lon poka pini sewi",
  "block.minecraft.banner.diagonal_right.yellow": "kipisi jelo lon poka pini sewi",
  "block.minecraft.banner.diagonal_up_left.black": "kipisi pimeja lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.blue": "kipisi pi laso telo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.brown": "kipisi pi loje ma lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.cyan": "kipisi laso lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.gray": "kipisi pi pimeja walo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.green": "kipisi pi laso kasi lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.light_blue": "kipisi pi laso sewi lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.light_gray": "kipisi pi walo pimeja lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.lime": "kipisi pi laso jelo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.magenta": "kipisi pi loje laso lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.orange": "kipisi pi loje jelo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.pink": "kipisi pi loje walo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.purple": "kipisi pi laso loje lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.red": "kipisi loje lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.white": "kipisi walo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_left.yellow": "kipisi jelo lon poka open anpa",
  "block.minecraft.banner.diagonal_up_right.black": "kipisi pimeja lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.blue": "kipisi pi laso telo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.brown": "kipisi pi loje ma lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.cyan": "kipisi laso lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.gray": "kipisi pi pimeja walo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.green": "kipisi pi laso kasi lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.light_blue": "kipisi pi laso sewi lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.light_gray": "kipisi pi walo pimeja lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.lime": "kipisi pi laso jelo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.magenta": "kipisi loje laso lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.orange": "kipisi pi loje jelo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.pink": "kipisi pi loje walo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.purple": "kipisi pi laso loje lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.red": "kipisi loje lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.white": "kipisi walo lon poka pini anpa",
  "block.minecraft.banner.diagonal_up_right.yellow": "kipisi jelo lon poka pini anpa",
  "block.minecraft.banner.flow.black": "esun pimeja",
  "block.minecraft.banner.flow.blue": "esun pi laso telo",
  "block.minecraft.banner.flow.brown": "esun pi loje ma",
  "block.minecraft.banner.flow.cyan": "esun laso",
  "block.minecraft.banner.flow.gray": "esun pi pimeja walo",
  "block.minecraft.banner.flow.green": "esun pi laso kasi",
  "block.minecraft.banner.flow.light_blue": "esun pi laso sewi",
  "block.minecraft.banner.flow.light_gray": "esun pi walo pimeja",
  "block.minecraft.banner.flow.lime": "esun pi laso jelo",
  "block.minecraft.banner.flow.magenta": "esun pi loje laso",
  "block.minecraft.banner.flow.orange": "esun pi loje jelo",
  "block.minecraft.banner.flow.pink": "esun pi loje walo",
  "block.minecraft.banner.flow.purple": "esun pi laso loje",
  "block.minecraft.banner.flow.red": "esun loje",
  "block.minecraft.banner.flow.white": "esun walo",
  "block.minecraft.banner.flow.yellow": "esun jelo",
  "block.minecraft.banner.flower.black": "sike kasi pimeja",
  "block.minecraft.banner.flower.blue": "sike kasi pi laso telo",
  "block.minecraft.banner.flower.brown": "sike kasi pi loje ma",
  "block.minecraft.banner.flower.cyan": "sike kasi laso",
  "block.minecraft.banner.flower.gray": "sike kasi pi pimeja walo",
  "block.minecraft.banner.flower.green": "sike kasi pi laso kasi",
  "block.minecraft.banner.flower.light_blue": "sike kasi pi laso sewi",
  "block.minecraft.banner.flower.light_gray": "sike kasi pi walo pimeja",
  "block.minecraft.banner.flower.lime": "sike kasi pi laso jelo",
  "block.minecraft.banner.flower.magenta": "sike kasi pi loje laso",
  "block.minecraft.banner.flower.orange": "sike kasi pi loje jelo",
  "block.minecraft.banner.flower.pink": "sike kasi pi loje walo",
  "block.minecraft.banner.flower.purple": "sike kasi pi laso loje",
  "block.minecraft.banner.flower.red": "sike kasi loje",
  "block.minecraft.banner.flower.white": "sike kasi walo",
  "block.minecraft.banner.flower.yellow": "sike kasi jelo",
  "block.minecraft.banner.globe.black": "sitelen pimeja pi sike ma",
  "block.minecraft.banner.globe.blue": "sitelen pi sike ma pi laso telo",
  "block.minecraft.banner.globe.brown": "sitelen pi ma ali pi loje ma",
  "block.minecraft.banner.globe.cyan": "sitelen laso pi sike ma",
  "block.minecraft.banner.globe.gray": "sitelen pi sike ma pi pimeja walo",
  "block.minecraft.banner.globe.green": "sitelen pi sike ma pi laso kasi",
  "block.minecraft.banner.globe.light_blue": "sitelen pi sike ma pi laso sewi",
  "block.minecraft.banner.globe.light_gray": "sitelen pi sike ma pi walo pimeja",
  "block.minecraft.banner.globe.lime": "sitelen pi sike ma pi laso jelo",
  "block.minecraft.banner.globe.magenta": "sitelen pi sike ma pi loje laso",
  "block.minecraft.banner.globe.orange": "sitelen pi sike ma pi loje jelo",
  "block.minecraft.banner.globe.pink": "sitelen pi sike ma pi loje walo",
  "block.minecraft.banner.globe.purple": "sitelen pi sike ma pi laso loje",
  "block.minecraft.banner.globe.red": "sitelen loje pi sike ma",
  "block.minecraft.banner.globe.white": "sitelen walo pi sike ma",
  "block.minecraft.banner.globe.yellow": "sitelen jelo pi sike ma",
  "block.minecraft.banner.gradient.black": "pimeja kama sewi",
  "block.minecraft.banner.gradient.blue": "laso telo kama sewi",
  "block.minecraft.banner.gradient.brown": "loje ma kama sewi",
  "block.minecraft.banner.gradient.cyan": "laso kama sewi",
  "block.minecraft.banner.gradient.gray": "pimeja walo kama sewi",
  "block.minecraft.banner.gradient.green": "laso kasi kama sewi",
  "block.minecraft.banner.gradient.light_blue": "laso sewi kama sewi",
  "block.minecraft.banner.gradient.light_gray": "walo pimeja kama sewi",
  "block.minecraft.banner.gradient.lime": "laso jelo kama sewi",
  "block.minecraft.banner.gradient.magenta": "loje laso kama sewi",
  "block.minecraft.banner.gradient.orange": "loje jelo kama sewi",
  "block.minecraft.banner.gradient.pink": "loje walo kama sewi",
  "block.minecraft.banner.gradient.purple": "laso loje kama sewi",
  "block.minecraft.banner.gradient.red": "loje kama sewi",
  "block.minecraft.banner.gradient.white": "walo kama sewi",
  "block.minecraft.banner.gradient.yellow": "jelo kama sewi",
  "block.minecraft.banner.gradient_up.black": "pimeja kama anpa",
  "block.minecraft.banner.gradient_up.blue": "laso telo kama anpa",
  "block.minecraft.banner.gradient_up.brown": "loje ma kama anpa",
  "block.minecraft.banner.gradient_up.cyan": "laso kama anpa",
  "block.minecraft.banner.gradient_up.gray": "pimeja walo kama anpa",
  "block.minecraft.banner.gradient_up.green": "laso kasi kama anpa",
  "block.minecraft.banner.gradient_up.light_blue": "laso sewi kama anpa",
  "block.minecraft.banner.gradient_up.light_gray": "walo pimeja kama anpa",
  "block.minecraft.banner.gradient_up.lime": "laso jelo kama anpa",
  "block.minecraft.banner.gradient_up.magenta": "loje laso kama anpa",
  "block.minecraft.banner.gradient_up.orange": "loje jelo kama anpa",
  "block.minecraft.banner.gradient_up.pink": "loje walo kama anpa",
  "block.minecraft.banner.gradient_up.purple": "laso loje kama anpa",
  "block.minecraft.banner.gradient_up.red": "loje kama anpa",
  "block.minecraft.banner.gradient_up.white": "walo kama anpa",
  "block.minecraft.banner.gradient_up.yellow": "jelo kama anpa",
  "block.minecraft.banner.guster.black": "monsuta kon pimeja",
  "block.minecraft.banner.guster.blue": "monsuta kon pi laso telo",
  "block.minecraft.banner.guster.brown": "monsuta kon pi loje ma",
  "block.minecraft.banner.guster.cyan": "monsuta kon laso",
  "block.minecraft.banner.guster.gray": "monsuta kon pi pimeja walo",
  "block.minecraft.banner.guster.green": "monsuta kon pi laso kasi",
  "block.minecraft.banner.guster.light_blue": "monsuta kon pi laso sewi",
  "block.minecraft.banner.guster.light_gray": "monsuta kon pi walo pimeja",
  "block.minecraft.banner.guster.lime": "monsuta kon pi laso jelo",
  "block.minecraft.banner.guster.magenta": "monsuta kon pi loje laso",
  "block.minecraft.banner.guster.orange": "monsuta kon pi loje jelo",
  "block.minecraft.banner.guster.pink": "monsuta kon pi loje walo",
  "block.minecraft.banner.guster.purple": "monsuta kon pi laso loje",
  "block.minecraft.banner.guster.red": "monsuta kon loje",
  "block.minecraft.banner.guster.white": "monsuta kon walo",
  "block.minecraft.banner.guster.yellow": "monsuta kon jelo",
  "block.minecraft.banner.half_horizontal.black": "kipisi sewi pimeja",
  "block.minecraft.banner.half_horizontal.blue": "kipisi sewi pi laso telo",
  "block.minecraft.banner.half_horizontal.brown": "kipisi sewi pi loje ma",
  "block.minecraft.banner.half_horizontal.cyan": "kipisi sewi laso",
  "block.minecraft.banner.half_horizontal.gray": "kipisi sewi pi pimeja walo",
  "block.minecraft.banner.half_horizontal.green": "kipisi sewi pi laso kasi",
  "block.minecraft.banner.half_horizontal.light_blue": "kipisi sewi pi laso sewi",
  "block.minecraft.banner.half_horizontal.light_gray": "kipisi sewi pi walo pimeja",
  "block.minecraft.banner.half_horizontal.lime": "kipisi sewi pi laso jelo",
  "block.minecraft.banner.half_horizontal.magenta": "kipisi sewi pi loje laso",
  "block.minecraft.banner.half_horizontal.orange": "kipisi sewi pi loje jelo",
  "block.minecraft.banner.half_horizontal.pink": "kipisi sewi pi loje walo",
  "block.minecraft.banner.half_horizontal.purple": "kipisi sewi pi laso loje",
  "block.minecraft.banner.half_horizontal.red": "kipisi sewi loje",
  "block.minecraft.banner.half_horizontal.white": "kipisi sewi walo",
  "block.minecraft.banner.half_horizontal.yellow": "kipisi sewi jelo",
  "block.minecraft.banner.half_horizontal_bottom.black": "kipisi anpa pimeja",
  "block.minecraft.banner.half_horizontal_bottom.blue": "kipisi anpa pi laso telo",
  "block.minecraft.banner.half_horizontal_bottom.brown": "kipisi anpa pi loje ma",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "kipisi anpa laso",
  "block.minecraft.banner.half_horizontal_bottom.gray": "kipisi anpa pi pimeja walo",
  "block.minecraft.banner.half_horizontal_bottom.green": "kipisi anpa pi laso kasi",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "kipisi anpa pi laso sewi",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "kipisi anpa pi walo pimeja",
  "block.minecraft.banner.half_horizontal_bottom.lime": "kipisi anpa pi laso jelo",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "kipisi anpa pi loje laso",
  "block.minecraft.banner.half_horizontal_bottom.orange": "kipisi anpa pi loje jelo",
  "block.minecraft.banner.half_horizontal_bottom.pink": "kipisi anpa pi loje walo",
  "block.minecraft.banner.half_horizontal_bottom.purple": "kipisi anpa pi laso loje",
  "block.minecraft.banner.half_horizontal_bottom.red": "kipisi anpa loje",
  "block.minecraft.banner.half_horizontal_bottom.white": "kipisi anpa walo",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "kipisi anpa jelo",
  "block.minecraft.banner.half_vertical.black": "kipisi pimeja lon poka open",
  "block.minecraft.banner.half_vertical.blue": "kipisi pi laso telo lon poka open",
  "block.minecraft.banner.half_vertical.brown": "kipisi pi loje ma lon poka open",
  "block.minecraft.banner.half_vertical.cyan": "kipisi laso lon poka open",
  "block.minecraft.banner.half_vertical.gray": "kipisi pi pimeja walo lon poka open",
  "block.minecraft.banner.half_vertical.green": "kipisi pi laso kasi lon poka open",
  "block.minecraft.banner.half_vertical.light_blue": "kipisi pi laso sewi lon poka open",
  "block.minecraft.banner.half_vertical.light_gray": "kipisi pi walo pimeja lon poka open",
  "block.minecraft.banner.half_vertical.lime": "kipisi pi laso jelo lon poka open",
  "block.minecraft.banner.half_vertical.magenta": "kipisi pi loje laso lon poka open",
  "block.minecraft.banner.half_vertical.orange": "kipisi pi loje jelo lon poka open",
  "block.minecraft.banner.half_vertical.pink": "kipisi pi loje walo lon poka open",
  "block.minecraft.banner.half_vertical.purple": "tu laso loje lon poka pilin",
  "block.minecraft.banner.half_vertical.red": "kipisi loje lon poka open",
  "block.minecraft.banner.half_vertical.white": "kipisi walo lon poka open",
  "block.minecraft.banner.half_vertical.yellow": "kipisi jelo lon poka open",
  "block.minecraft.banner.half_vertical_right.black": "kipisi pimeja lon poka pini",
  "block.minecraft.banner.half_vertical_right.blue": "kipisi pi laso telo lon poka pini",
  "block.minecraft.banner.half_vertical_right.brown": "kipisi pi loje ma lon poka pini",
  "block.minecraft.banner.half_vertical_right.cyan": "kipisi laso lon poka pini",
  "block.minecraft.banner.half_vertical_right.gray": "kipisi pi pimeja walo lon poka pini",
  "block.minecraft.banner.half_vertical_right.green": "kipisi pi laso kasi lon poka pini",
  "block.minecraft.banner.half_vertical_right.light_blue": "kipisi pi laso sewi lon poka pini",
  "block.minecraft.banner.half_vertical_right.light_gray": "kipisi pi walo pimeja lon poka pini",
  "block.minecraft.banner.half_vertical_right.lime": "kipisi pi laso jelo lon poka pini",
  "block.minecraft.banner.half_vertical_right.magenta": "kipisi pi loje laso lon poka pini",
  "block.minecraft.banner.half_vertical_right.orange": "kipisi pi loje jelo lon poka pini",
  "block.minecraft.banner.half_vertical_right.pink": "kipisi pi loje walo lon poka pini",
  "block.minecraft.banner.half_vertical_right.purple": "kipisi pi laso loje lon poka pini",
  "block.minecraft.banner.half_vertical_right.red": "kipisi loje lon poka pini",
  "block.minecraft.banner.half_vertical_right.white": "kipisi walo lon poka pini",
  "block.minecraft.banner.half_vertical_right.yellow": "kipisi jelo lon poka pini",
  "block.minecraft.banner.mojang.black": "ijo pimeja",
  "block.minecraft.banner.mojang.blue": "ijo pi laso telo",
  "block.minecraft.banner.mojang.brown": "ijo pi loje ma",
  "block.minecraft.banner.mojang.cyan": "ijo laso",
  "block.minecraft.banner.mojang.gray": "ijo pi pimeja walo",
  "block.minecraft.banner.mojang.green": "ijo pi laso kasi",
  "block.minecraft.banner.mojang.light_blue": "ijo pi laso sewi",
  "block.minecraft.banner.mojang.light_gray": "ijo pi walo pimeja",
  "block.minecraft.banner.mojang.lime": "ijo pi laso jelo",
  "block.minecraft.banner.mojang.magenta": "ijo pi loje laso",
  "block.minecraft.banner.mojang.orange": "ijo pi loje jelo",
  "block.minecraft.banner.mojang.pink": "ijo pi loje walo",
  "block.minecraft.banner.mojang.purple": "ijo pi laso loje",
  "block.minecraft.banner.mojang.red": "ijo loje",
  "block.minecraft.banner.mojang.white": "ijo walo",
  "block.minecraft.banner.mojang.yellow": "ijo jelo",
  "block.minecraft.banner.piglin.black": "nena soweli pimeja",
  "block.minecraft.banner.piglin.blue": "nena soweli pi laso telo",
  "block.minecraft.banner.piglin.brown": "nena soweli pi loje ma",
  "block.minecraft.banner.piglin.cyan": "nena soweli laso",
  "block.minecraft.banner.piglin.gray": "nena soweli pimeja walo",
  "block.minecraft.banner.piglin.green": "nena soweli pi laso kasi",
  "block.minecraft.banner.piglin.light_blue": "nena soweli pi laso sewi",
  "block.minecraft.banner.piglin.light_gray": "nena soweli walo pimeja",
  "block.minecraft.banner.piglin.lime": "nena soweli laso jelo",
  "block.minecraft.banner.piglin.magenta": "nena soweli loje laso",
  "block.minecraft.banner.piglin.orange": "nena soweli loje jelo",
  "block.minecraft.banner.piglin.pink": "nena soweli loje walo",
  "block.minecraft.banner.piglin.purple": "nena soweli laso loje",
  "block.minecraft.banner.piglin.red": "nena soweli loje",
  "block.minecraft.banner.piglin.white": "nena soweli walo",
  "block.minecraft.banner.piglin.yellow": "nena soweli jelo",
  "block.minecraft.banner.rhombus.black": "leko insa pimeja",
  "block.minecraft.banner.rhombus.blue": "leko insa pi laso telo",
  "block.minecraft.banner.rhombus.brown": "leko insa pi loje ma",
  "block.minecraft.banner.rhombus.cyan": "leko insa laso",
  "block.minecraft.banner.rhombus.gray": "leko insa pi pimeja walo",
  "block.minecraft.banner.rhombus.green": "leko insa pi laso kasi",
  "block.minecraft.banner.rhombus.light_blue": "leko insa pi laso sewi",
  "block.minecraft.banner.rhombus.light_gray": "leko insa pi walo pimeja",
  "block.minecraft.banner.rhombus.lime": "leko insa pi laso jelo",
  "block.minecraft.banner.rhombus.magenta": "leko insa pi loje laso",
  "block.minecraft.banner.rhombus.orange": "leko insa pi loje jelo",
  "block.minecraft.banner.rhombus.pink": "leko insa pi loje walo",
  "block.minecraft.banner.rhombus.purple": "leko insa pi laso loje",
  "block.minecraft.banner.rhombus.red": "leko insa loje",
  "block.minecraft.banner.rhombus.white": "leko insa walo",
  "block.minecraft.banner.rhombus.yellow": "leko insa jelo",
  "block.minecraft.banner.skull.black": "sitelen moli pimeja",
  "block.minecraft.banner.skull.blue": "sitelen moli pi laso telo",
  "block.minecraft.banner.skull.brown": "sitelen moli pi loje ma",
  "block.minecraft.banner.skull.cyan": "sitelen moli laso",
  "block.minecraft.banner.skull.gray": "sitelen moli pi pimeja walo",
  "block.minecraft.banner.skull.green": "sitelen moli pi laso kasi",
  "block.minecraft.banner.skull.light_blue": "sitelen moli pi laso sewi",
  "block.minecraft.banner.skull.light_gray": "sitelen moli pi walo pimeja",
  "block.minecraft.banner.skull.lime": "sitelen moli pi laso jelo",
  "block.minecraft.banner.skull.magenta": "sitelen moli pi loje laso",
  "block.minecraft.banner.skull.orange": "sitelen moli pi loje jelo",
  "block.minecraft.banner.skull.pink": "sitelen moli pi loje walo",
  "block.minecraft.banner.skull.purple": "sitelen moli pi laso loje",
  "block.minecraft.banner.skull.red": "sitelen moli loje",
  "block.minecraft.banner.skull.white": "sitelen moli walo",
  "block.minecraft.banner.skull.yellow": "sitelen moli jelo",
  "block.minecraft.banner.small_stripes.black": "palisa mute pimeja",
  "block.minecraft.banner.small_stripes.blue": "palisa mute pi laso telo",
  "block.minecraft.banner.small_stripes.brown": "palisa mute pi loje ma",
  "block.minecraft.banner.small_stripes.cyan": "palisa mute laso",
  "block.minecraft.banner.small_stripes.gray": "palisa mute pi pimeja walo",
  "block.minecraft.banner.small_stripes.green": "palisa mute pi laso kasi",
  "block.minecraft.banner.small_stripes.light_blue": "palisa mute pi laso sewi",
  "block.minecraft.banner.small_stripes.light_gray": "palisa mute pi walo pimeja",
  "block.minecraft.banner.small_stripes.lime": "palisa mute pi laso jelo",
  "block.minecraft.banner.small_stripes.magenta": "palisa mute pi loje laso",
  "block.minecraft.banner.small_stripes.orange": "palisa mute pi loje jelo",
  "block.minecraft.banner.small_stripes.pink": "palisa mute pi loje walo",
  "block.minecraft.banner.small_stripes.purple": "palisa mute laso loje",
  "block.minecraft.banner.small_stripes.red": "palisa mute loje",
  "block.minecraft.banner.small_stripes.white": "palisa mute walo",
  "block.minecraft.banner.small_stripes.yellow": "palisa mute jelo",
  "block.minecraft.banner.square_bottom_left.black": "leko pimeja lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.blue": "leko pi laso telo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.brown": "leko pi loje ma lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.cyan": "leko laso lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.gray": "leko pi pimeja walo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.green": "leko pi laso kasi lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.light_blue": "leko pi laso sewi lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.light_gray": "leko pi walo pimeja lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.lime": "leko pi laso jelo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.magenta": "leko pi loje laso lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.orange": "leko pi loje jelo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.pink": "leko pi loje walo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.purple": "leko pi laso loje lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.red": "leko loje lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.white": "leko walo lon poka open anpa",
  "block.minecraft.banner.square_bottom_left.yellow": "leko jelo lon poka open anpa",
  "block.minecraft.banner.square_bottom_right.black": "leko pimeja lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.blue": "leko pi laso telo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.brown": "leko pi loje ma lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.cyan": "leko laso lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.gray": "leko pi pimeja walo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.green": "leko pi laso kasi lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.light_blue": "leko pi laso sewi lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.light_gray": "leko pi walo pimeja lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.lime": "leko pi laso jelo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.magenta": "leko pi loje laso lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.orange": "leko pi loje jelo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.pink": "leko pi loje walo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.purple": "leko pi laso loje lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.red": "leko loje lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.white": "leko walo lon poka pini anpa",
  "block.minecraft.banner.square_bottom_right.yellow": "leko jelo lon poka pini anpa",
  "block.minecraft.banner.square_top_left.black": "leko pimeja lon poka open sewi",
  "block.minecraft.banner.square_top_left.blue": "leko pi laso telo lon poka open sewi",
  "block.minecraft.banner.square_top_left.brown": "leko pi loje ma lon poka open sewi",
  "block.minecraft.banner.square_top_left.cyan": "leko laso lon poka open sewi",
  "block.minecraft.banner.square_top_left.gray": "leko pi pimeja walo lon poka open sewi",
  "block.minecraft.banner.square_top_left.green": "leko pi laso kasi lon poka open sewi",
  "block.minecraft.banner.square_top_left.light_blue": "leko pi laso sewi lon poka open sewi",
  "block.minecraft.banner.square_top_left.light_gray": "leko pi walo pimeja lon poka open sewi",
  "block.minecraft.banner.square_top_left.lime": "leko pi laso jelo lon poka open sewi",
  "block.minecraft.banner.square_top_left.magenta": "leko pi loje laso lon poka open sewi",
  "block.minecraft.banner.square_top_left.orange": "leko pi loje jelo lon poka open sewi",
  "block.minecraft.banner.square_top_left.pink": "leko pi loje walo lon poka open sewi",
  "block.minecraft.banner.square_top_left.purple": "leko pi laso loje lon poka open sewi",
  "block.minecraft.banner.square_top_left.red": "leko loje lon poka open sewi",
  "block.minecraft.banner.square_top_left.white": "leko walo lon poka open sewi",
  "block.minecraft.banner.square_top_left.yellow": "leko jelo lon poka open sewi",
  "block.minecraft.banner.square_top_right.black": "leko pimeja lon poka pini sewi",
  "block.minecraft.banner.square_top_right.blue": "leko pi laso telo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.brown": "leko pi loje ma lon poka pini sewi",
  "block.minecraft.banner.square_top_right.cyan": "leko laso lon poka pini sewi",
  "block.minecraft.banner.square_top_right.gray": "leko pi pimeja walo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.green": "leko pi laso kasi lon poka pini sewi",
  "block.minecraft.banner.square_top_right.light_blue": "leko pi laso sewi lon poka pini sewi",
  "block.minecraft.banner.square_top_right.light_gray": "leko pi walo pimeja lon poka pini sewi",
  "block.minecraft.banner.square_top_right.lime": "leko pi laso jelo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.magenta": "leko pi loje laso lon poka pini sewi",
  "block.minecraft.banner.square_top_right.orange": "leko pi loje jelo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.pink": "leko pi loje walo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.purple": "leko pi laso loje lon poka pini sewi",
  "block.minecraft.banner.square_top_right.red": "leko loje lon poka pini sewi",
  "block.minecraft.banner.square_top_right.white": "leko walo lon poka pini sewi",
  "block.minecraft.banner.square_top_right.yellow": "leko pi jelo lon poka pini sewi",
  "block.minecraft.banner.straight_cross.black": "sitelen '+' pimeja",
  "block.minecraft.banner.straight_cross.blue": "sitelen '+' pi laso telo",
  "block.minecraft.banner.straight_cross.brown": "sitelen '+' pi loje ma",
  "block.minecraft.banner.straight_cross.cyan": "sitelen '+' laso",
  "block.minecraft.banner.straight_cross.gray": "sitelen '+' pi pimeja walo",
  "block.minecraft.banner.straight_cross.green": "sitelen '+' pi laso kasi",
  "block.minecraft.banner.straight_cross.light_blue": "sitelen '+' pi laso sewi",
  "block.minecraft.banner.straight_cross.light_gray": "sitelen '+' pi walo pimeja",
  "block.minecraft.banner.straight_cross.lime": "sitelen '+' pi laso jelo",
  "block.minecraft.banner.straight_cross.magenta": "sitelen '+' pi loje laso",
  "block.minecraft.banner.straight_cross.orange": "sitelen '+' pi loje jelo",
  "block.minecraft.banner.straight_cross.pink": "sitelen '+' pi loje walo",
  "block.minecraft.banner.straight_cross.purple": "sitelen '+' pi laso loje",
  "block.minecraft.banner.straight_cross.red": "sitelen '+' loje",
  "block.minecraft.banner.straight_cross.white": "sitelen '+' walo",
  "block.minecraft.banner.straight_cross.yellow": "sitelen '+' jelo",
  "block.minecraft.banner.stripe_bottom.black": "leko anpa pimeja",
  "block.minecraft.banner.stripe_bottom.blue": "leko anpa pi laso telo",
  "block.minecraft.banner.stripe_bottom.brown": "leko anpa pi loje ma",
  "block.minecraft.banner.stripe_bottom.cyan": "leko anpa laso",
  "block.minecraft.banner.stripe_bottom.gray": "leko anpa pi pimeja walo",
  "block.minecraft.banner.stripe_bottom.green": "leko anpa pi laso kasi",
  "block.minecraft.banner.stripe_bottom.light_blue": "leko anpa pi laso sewi",
  "block.minecraft.banner.stripe_bottom.light_gray": "leko anpa pi walo pimeja",
  "block.minecraft.banner.stripe_bottom.lime": "leko anpa pi laso jelo",
  "block.minecraft.banner.stripe_bottom.magenta": "leko anpa pi loje laso",
  "block.minecraft.banner.stripe_bottom.orange": "leko anpa pi loje jelo",
  "block.minecraft.banner.stripe_bottom.pink": "leko anpa pi loje walo",
  "block.minecraft.banner.stripe_bottom.purple": "leko anpa pi laso loje",
  "block.minecraft.banner.stripe_bottom.red": "leko anpa loje",
  "block.minecraft.banner.stripe_bottom.white": "leko anpa walo",
  "block.minecraft.banner.stripe_bottom.yellow": "leko anpa jelo",
  "block.minecraft.banner.stripe_center.black": "palisa pimeja",
  "block.minecraft.banner.stripe_center.blue": "palisa pi laso telo",
  "block.minecraft.banner.stripe_center.brown": "palisa pi loje ma",
  "block.minecraft.banner.stripe_center.cyan": "palisa laso",
  "block.minecraft.banner.stripe_center.gray": "palisa pi pimeja walo",
  "block.minecraft.banner.stripe_center.green": "palisa pi laso kasi",
  "block.minecraft.banner.stripe_center.light_blue": "palisa pi laso sewi",
  "block.minecraft.banner.stripe_center.light_gray": "palisa pi walo pimeja",
  "block.minecraft.banner.stripe_center.lime": "palisa pi laso jelo",
  "block.minecraft.banner.stripe_center.magenta": "palisa pi loje laso",
  "block.minecraft.banner.stripe_center.orange": "palisa pi loje jelo",
  "block.minecraft.banner.stripe_center.pink": "palisa pi loje walo",
  "block.minecraft.banner.stripe_center.purple": "palisa pi laso loje",
  "block.minecraft.banner.stripe_center.red": "palisa loje",
  "block.minecraft.banner.stripe_center.white": "palisa walo",
  "block.minecraft.banner.stripe_center.yellow": "palisa jelo",
  "block.minecraft.banner.stripe_downleft.black": "sitelen '/' pimeja",
  "block.minecraft.banner.stripe_downleft.blue": "sitelen '/' pi laso telo",
  "block.minecraft.banner.stripe_downleft.brown": "sitelen '/' pi loje ma",
  "block.minecraft.banner.stripe_downleft.cyan": "sitelen '/' laso",
  "block.minecraft.banner.stripe_downleft.gray": "sitelen '/' pi pimeja walo",
  "block.minecraft.banner.stripe_downleft.green": "sitelen '/' pi laso kasi",
  "block.minecraft.banner.stripe_downleft.light_blue": "sitelen '/' pi laso sewi",
  "block.minecraft.banner.stripe_downleft.light_gray": "sitelen '/' pi walo pimeja",
  "block.minecraft.banner.stripe_downleft.lime": "sitelen '/' pi laso jelo",
  "block.minecraft.banner.stripe_downleft.magenta": "sitelen '/' pi loje laso",
  "block.minecraft.banner.stripe_downleft.orange": "sitelen '/' pi loje jelo",
  "block.minecraft.banner.stripe_downleft.pink": "sitelen '/' pi loje walo",
  "block.minecraft.banner.stripe_downleft.purple": "sitelen '/' pi laso loje",
  "block.minecraft.banner.stripe_downleft.red": "sitelen '/' loje",
  "block.minecraft.banner.stripe_downleft.white": "sitelen '/' walo",
  "block.minecraft.banner.stripe_downleft.yellow": "sitelen '/' jelo",
  "block.minecraft.banner.stripe_downright.black": "sitelen '\\' pimeja",
  "block.minecraft.banner.stripe_downright.blue": "sitelen '\\' pi laso telo",
  "block.minecraft.banner.stripe_downright.brown": "sitelen '\\' pi loje ma",
  "block.minecraft.banner.stripe_downright.cyan": "sitelen '\\' laso",
  "block.minecraft.banner.stripe_downright.gray": "sitelen '\\' pi pimeja walo",
  "block.minecraft.banner.stripe_downright.green": "sitelen '\\' pi laso kasi",
  "block.minecraft.banner.stripe_downright.light_blue": "sitelen '\\' pi laso sewi",
  "block.minecraft.banner.stripe_downright.light_gray": "sitelen '\\' pi walo pimeja",
  "block.minecraft.banner.stripe_downright.lime": "sitelen '\\' pi laso jelo",
  "block.minecraft.banner.stripe_downright.magenta": "sitelen '\\' pi loje laso",
  "block.minecraft.banner.stripe_downright.orange": "sitelen '\\' pi loje jelo",
  "block.minecraft.banner.stripe_downright.pink": "sitelen '\\' pi loje walo",
  "block.minecraft.banner.stripe_downright.purple": "sitelen '\\' laso loje",
  "block.minecraft.banner.stripe_downright.red": "sitelen '\\' loje",
  "block.minecraft.banner.stripe_downright.white": "sitelen '\\' walo",
  "block.minecraft.banner.stripe_downright.yellow": "sitelen '\\' jelo",
  "block.minecraft.banner.stripe_left.black": "palisa pimeja lon poka open",
  "block.minecraft.banner.stripe_left.blue": "palisa pi laso telo lon poka open",
  "block.minecraft.banner.stripe_left.brown": "palisa pi loje ma lon poka open",
  "block.minecraft.banner.stripe_left.cyan": "palisa laso lon poka open",
  "block.minecraft.banner.stripe_left.gray": "palisa pi pimeja walo lon poka open",
  "block.minecraft.banner.stripe_left.green": "palisa pi laso kasi lon poka open",
  "block.minecraft.banner.stripe_left.light_blue": "palisa pi laso sewi lon poka open",
  "block.minecraft.banner.stripe_left.light_gray": "palisa pi walo pimeja lon poka open",
  "block.minecraft.banner.stripe_left.lime": "palisa pi laso jelo lon poka open",
  "block.minecraft.banner.stripe_left.magenta": "palisa pi loje laso lon poka open",
  "block.minecraft.banner.stripe_left.orange": "palisa pi loje jelo lon poka open",
  "block.minecraft.banner.stripe_left.pink": "palisa pi loje walo lon poka open",
  "block.minecraft.banner.stripe_left.purple": "palisa pi laso loje lon poka open",
  "block.minecraft.banner.stripe_left.red": "palisa loje lon poka open",
  "block.minecraft.banner.stripe_left.white": "palisa walo lon poka open",
  "block.minecraft.banner.stripe_left.yellow": "palisa jelo lon poka open",
  "block.minecraft.banner.stripe_middle.black": "linja supa pimeja",
  "block.minecraft.banner.stripe_middle.blue": "linja supa pi laso telo",
  "block.minecraft.banner.stripe_middle.brown": "linja supa pi loje ma",
  "block.minecraft.banner.stripe_middle.cyan": "linja supa laso",
  "block.minecraft.banner.stripe_middle.gray": "linja supa pi pimeja walo",
  "block.minecraft.banner.stripe_middle.green": "linja supa pi laso kasi",
  "block.minecraft.banner.stripe_middle.light_blue": "linja supa pi laso sewi",
  "block.minecraft.banner.stripe_middle.light_gray": "linja supa pi walo pimeja",
  "block.minecraft.banner.stripe_middle.lime": "linja supa pi laso jelo",
  "block.minecraft.banner.stripe_middle.magenta": "linja supa pi loje laso",
  "block.minecraft.banner.stripe_middle.orange": "linja supa pi loje jelo",
  "block.minecraft.banner.stripe_middle.pink": "linja supa pi loje walo",
  "block.minecraft.banner.stripe_middle.purple": "linja supa pi laso loje",
  "block.minecraft.banner.stripe_middle.red": "linja supa loje",
  "block.minecraft.banner.stripe_middle.white": "linja supa walo",
  "block.minecraft.banner.stripe_middle.yellow": "linja supa jelo",
  "block.minecraft.banner.stripe_right.black": "palisa pimeja lon poka pini",
  "block.minecraft.banner.stripe_right.blue": "palisa pi laso telo lon poka pini",
  "block.minecraft.banner.stripe_right.brown": "palisa pi loje ma lon poka pini",
  "block.minecraft.banner.stripe_right.cyan": "palisa laso lon poka pini",
  "block.minecraft.banner.stripe_right.gray": "palisa pi pimeja walo lon poka pini",
  "block.minecraft.banner.stripe_right.green": "palisa pi laso kasi lon poka pini",
  "block.minecraft.banner.stripe_right.light_blue": "palisa pi laso sewi lon poka pini",
  "block.minecraft.banner.stripe_right.light_gray": "palisa pi walo pimeja lon poka pini",
  "block.minecraft.banner.stripe_right.lime": "palisa pi laso jelo lon poka pini",
  "block.minecraft.banner.stripe_right.magenta": "palisa pi loje laso lon poka pini",
  "block.minecraft.banner.stripe_right.orange": "palisa pi loje jelo lon poka pini",
  "block.minecraft.banner.stripe_right.pink": "palisa pi loje walo lon poka pini",
  "block.minecraft.banner.stripe_right.purple": "palisa pi laso loje lon poka pini",
  "block.minecraft.banner.stripe_right.red": "palisa loje lon poka pini",
  "block.minecraft.banner.stripe_right.white": "palisa walo lon poka pini",
  "block.minecraft.banner.stripe_right.yellow": "palisa jelo lon poka pini",
  "block.minecraft.banner.stripe_top.black": "leko sewi pimeja",
  "block.minecraft.banner.stripe_top.blue": "leko sewi pi laso telo",
  "block.minecraft.banner.stripe_top.brown": "leko sewi pi loje ma",
  "block.minecraft.banner.stripe_top.cyan": "leko sewi laso",
  "block.minecraft.banner.stripe_top.gray": "leko sewi pi pimeja walo",
  "block.minecraft.banner.stripe_top.green": "leko sewi pi laso kasi",
  "block.minecraft.banner.stripe_top.light_blue": "leko sewi pi laso sewi",
  "block.minecraft.banner.stripe_top.light_gray": "leko sewi pi walo pimeja",
  "block.minecraft.banner.stripe_top.lime": "leko sewi pi laso jelo",
  "block.minecraft.banner.stripe_top.magenta": "leko sewi pi loje laso",
  "block.minecraft.banner.stripe_top.orange": "leko sewi pi loje jelo",
  "block.minecraft.banner.stripe_top.pink": "leko sewi pi loje walo",
  "block.minecraft.banner.stripe_top.purple": "leko sewi pi laso loje",
  "block.minecraft.banner.stripe_top.red": "leko sewi loje",
  "block.minecraft.banner.stripe_top.white": "leko sewi walo",
  "block.minecraft.banner.stripe_top.yellow": "leko sewi jelo",
  "block.minecraft.banner.triangle_bottom.black": "nena pimeja",
  "block.minecraft.banner.triangle_bottom.blue": "nena pi laso telo",
  "block.minecraft.banner.triangle_bottom.brown": "nena pi loje ma",
  "block.minecraft.banner.triangle_bottom.cyan": "nena laso",
  "block.minecraft.banner.triangle_bottom.gray": "nena pi pimeja walo",
  "block.minecraft.banner.triangle_bottom.green": "nena pi laso kasi",
  "block.minecraft.banner.triangle_bottom.light_blue": "nena pi laso sewi",
  "block.minecraft.banner.triangle_bottom.light_gray": "nena pi walo pimeja",
  "block.minecraft.banner.triangle_bottom.lime": "nena pi laso jelo",
  "block.minecraft.banner.triangle_bottom.magenta": "nena pi loje laso",
  "block.minecraft.banner.triangle_bottom.orange": "nena pi loje jelo",
  "block.minecraft.banner.triangle_bottom.pink": "nena pi loje walo",
  "block.minecraft.banner.triangle_bottom.purple": "nena pi laso loje",
  "block.minecraft.banner.triangle_bottom.red": "nena loje",
  "block.minecraft.banner.triangle_bottom.white": "nena walo",
  "block.minecraft.banner.triangle_bottom.yellow": "nena jelo",
  "block.minecraft.banner.triangle_top.black": "nena sewi pimeja",
  "block.minecraft.banner.triangle_top.blue": "nena sewi pi laso telo",
  "block.minecraft.banner.triangle_top.brown": "nena sewi pi loje ma",
  "block.minecraft.banner.triangle_top.cyan": "nena sewi laso",
  "block.minecraft.banner.triangle_top.gray": "nena sewi pi pimeja walo",
  "block.minecraft.banner.triangle_top.green": "nena sewi pi laso kasi",
  "block.minecraft.banner.triangle_top.light_blue": "nena sewi pi laso sewi",
  "block.minecraft.banner.triangle_top.light_gray": "nena sewi pi walo pimeja",
  "block.minecraft.banner.triangle_top.lime": "nena sewi pi laso jelo",
  "block.minecraft.banner.triangle_top.magenta": "nena sewi pi loje laso",
  "block.minecraft.banner.triangle_top.orange": "nena sewi pi loje jelo",
  "block.minecraft.banner.triangle_top.pink": "nena sewi pi loje walo",
  "block.minecraft.banner.triangle_top.purple": "nena sewi pi laso loje",
  "block.minecraft.banner.triangle_top.red": "nena sewi loje",
  "block.minecraft.banner.triangle_top.white": "nena sewi walo",
  "block.minecraft.banner.triangle_top.yellow": "nena sewi jelo",
  "block.minecraft.banner.triangles_bottom.black": "nena mute anpa pimeja",
  "block.minecraft.banner.triangles_bottom.blue": "nena mute anpa pi laso telo",
  "block.minecraft.banner.triangles_bottom.brown": "nena mute anpa pi loje ma",
  "block.minecraft.banner.triangles_bottom.cyan": "nena mute anpa laso",
  "block.minecraft.banner.triangles_bottom.gray": "nena mute anpa pi pimeja walo",
  "block.minecraft.banner.triangles_bottom.green": "nena mute anpa pi laso kasi",
  "block.minecraft.banner.triangles_bottom.light_blue": "nena mute anpa pi laso sewi",
  "block.minecraft.banner.triangles_bottom.light_gray": "nena mute anpa pi walo pimeja",
  "block.minecraft.banner.triangles_bottom.lime": "nena mute anpa pi laso jelo",
  "block.minecraft.banner.triangles_bottom.magenta": "nena mute anpa pi loje laso",
  "block.minecraft.banner.triangles_bottom.orange": "nena mute anpa pi loje jelo",
  "block.minecraft.banner.triangles_bottom.pink": "nena mute anpa pi loje walo",
  "block.minecraft.banner.triangles_bottom.purple": "nena mute anpa laso loje",
  "block.minecraft.banner.triangles_bottom.red": "nena mute anpa loje",
  "block.minecraft.banner.triangles_bottom.white": "nena mute anpa walo",
  "block.minecraft.banner.triangles_bottom.yellow": "nena mute anpa jelo",
  "block.minecraft.banner.triangles_top.black": "nena mute sewi pimeja",
  "block.minecraft.banner.triangles_top.blue": "nena mute sewi pi laso telo",
  "block.minecraft.banner.triangles_top.brown": "nena mute sewi pi loje ma",
  "block.minecraft.banner.triangles_top.cyan": "nena mute sewi laso",
  "block.minecraft.banner.triangles_top.gray": "nena mute sewi pi pimeja walo",
  "block.minecraft.banner.triangles_top.green": "nena mute sewi pi laso kasi",
  "block.minecraft.banner.triangles_top.light_blue": "nena mute sewi pi laso sewi",
  "block.minecraft.banner.triangles_top.light_gray": "nena mute sewi pi walo pimeja",
  "block.minecraft.banner.triangles_top.lime": "nena mute sewi pi laso jelo",
  "block.minecraft.banner.triangles_top.magenta": "nena mute sewi pi loje laso",
  "block.minecraft.banner.triangles_top.orange": "nena mute sewi pi loje jelo",
  "block.minecraft.banner.triangles_top.pink": "nena mute sewi pi loje walo",
  "block.minecraft.banner.triangles_top.purple": "nena mute sewi laso loje",
  "block.minecraft.banner.triangles_top.red": "nena mute sewi loje",
  "block.minecraft.banner.triangles_top.white": "nena mute sewi walo",
  "block.minecraft.banner.triangles_top.yellow": "nena mute sewi jelo",
  "block.minecraft.barrel": "poki sike",
  "block.minecraft.barrier": "sinpin kon",
  "block.minecraft.basalt": "kiwen palisa pimeja",
  "block.minecraft.beacon": "ilo wawa",
  "block.minecraft.beacon.primary": "wawa nanpa wan",
  "block.minecraft.beacon.secondary": "wawa nanpa tu",
  "block.minecraft.bed.no_sleep": "sina ken lape lon tenpo pimeja anu tenpo pi linja suno",
  "block.minecraft.bed.not_safe": "sina ken ala lape tan ni: monsuta li lon poka",
  "block.minecraft.bed.obstructed": "sina ken ala kepeken supa ni tan ni: ijo li lon ona",
  "block.minecraft.bed.occupied": "jan li kepeken supa lape ni",
  "block.minecraft.bed.too_far_away": "sina ken ala lape tan ni: supa lape li lon poka ala",
  "block.minecraft.bedrock": "kiwen pi pakala ala",
  "block.minecraft.bee_nest": "tomo pi pipi suwi",
  "block.minecraft.beehive": "tomo pali pi pipi suwi",
  "block.minecraft.beetroots": "kili ma loje",
  "block.minecraft.bell": "ilo kalama jelo",
  "block.minecraft.big_dripleaf": "kasi supa",
  "block.minecraft.big_dripleaf_stem": "sijelo pi kasi supa",
  "block.minecraft.birch_button": "nena ilo pi kasi jelo",
  "block.minecraft.birch_door": "lupa pi kasi jelo",
  "block.minecraft.birch_fence": "sinpin palisa pi kasi jelo",
  "block.minecraft.birch_fence_gate": "sinpin tawa pi kasi jelo",
  "block.minecraft.birch_hanging_sign": "lipu sitelen sewi pi kasi jelo",
  "block.minecraft.birch_leaves": "lipu pi kasi jelo",
  "block.minecraft.birch_log": "sijelo pi kasi jelo",
  "block.minecraft.birch_planks": "kiwen kipisi pi kasi jelo",
  "block.minecraft.birch_pressure_plate": "supa noka pi kasi jelo",
  "block.minecraft.birch_sapling": "kasi jelo sin",
  "block.minecraft.birch_shelf": "poki sinpin pi kasi jelo",
  "block.minecraft.birch_sign": "lipu sitelen pi kasi jelo",
  "block.minecraft.birch_slab": "supa pi kasi jelo",
  "block.minecraft.birch_stairs": "leko sewi pi kasi jelo",
  "block.minecraft.birch_trapdoor": "lupa anpa pi kasi jelo",
  "block.minecraft.birch_wall_hanging_sign": "lipu sitelen sewi pi kasi jelo lon sinpin",
  "block.minecraft.birch_wall_sign": "lipu sitelen pi kasi jelo lon sinpin",
  "block.minecraft.birch_wood": "kiwen pi kasi jelo",
  "block.minecraft.black_banner": "len sitelen pimeja",
  "block.minecraft.black_bed": "supa lape pimeja",
  "block.minecraft.black_candle": "palisa suno lili pimeja",
  "block.minecraft.black_candle_cake": "palisa suno lili pimeja lon pan suwi",
  "block.minecraft.black_carpet": "len anpa pimeja",
  "block.minecraft.black_concrete": "kiwen kule pimeja",
  "block.minecraft.black_concrete_powder": "ko kule pimeja",
  "block.minecraft.black_glazed_terracotta": "kiwen namako pimeja",
  "block.minecraft.black_shulker_box": "poki pimeja pi monsuta Shulker",
  "block.minecraft.black_stained_glass": "kiwen lukin pimeja",
  "block.minecraft.black_stained_glass_pane": "sinpin lukin pimeja",
  "block.minecraft.black_terracotta": "ma kiwen pimeja",
  "block.minecraft.black_wool": "len pimeja",
  "block.minecraft.blackstone": "kiwen pimeja",
  "block.minecraft.blackstone_slab": "supa kiwen pimeja",
  "block.minecraft.blackstone_stairs": "leko sewi pi kiwen pimeja",
  "block.minecraft.blackstone_wall": "sinpin kiwen pimeja",
  "block.minecraft.blast_furnace": "poki pi seli kiwen",
  "block.minecraft.blue_banner": "len sitelen pi laso telo",
  "block.minecraft.blue_bed": "supa lape pi laso telo",
  "block.minecraft.blue_candle": "palisa suno lili pi laso telo",
  "block.minecraft.blue_candle_cake": "palisa suno lili pi laso telo lon pan suwi",
  "block.minecraft.blue_carpet": "len anpa pi laso telo",
  "block.minecraft.blue_concrete": "kiwen kule pi laso telo",
  "block.minecraft.blue_concrete_powder": "ko kule pi laso telo",
  "block.minecraft.blue_glazed_terracotta": "kiwen namako pi laso telo",
  "block.minecraft.blue_ice": "kiwen telo laso",
  "block.minecraft.blue_orchid": "kasi pi laso sewi",
  "block.minecraft.blue_shulker_box": "poki pi laso telo pi monsuta Shulker",
  "block.minecraft.blue_stained_glass": "kiwen lukin pi laso telo",
  "block.minecraft.blue_stained_glass_pane": "sinpin lukin pi laso telo",
  "block.minecraft.blue_terracotta": "ma kiwen pi laso telo",
  "block.minecraft.blue_wool": "len pi laso telo",
  "block.minecraft.bone_block": "kiwen sijelo suli",
  "block.minecraft.bookshelf": "leko lipu",
  "block.minecraft.brain_coral": "kiwen kala pi loje walo",
  "block.minecraft.brain_coral_block": "kiwen kala suli pi loje walo",
  "block.minecraft.brain_coral_fan": "lipu pi kiwen kala pi loje walo",
  "block.minecraft.brain_coral_wall_fan": "lipu sinpin pi kiwen kala pi loje walo",
  "block.minecraft.brewing_stand": "ilo pi telo wawa",
  "block.minecraft.brick_slab": "supa pi kiwen leko loje",
  "block.minecraft.brick_stairs": "leko sewi pi kiwen leko loje",
  "block.minecraft.brick_wall": "sinpin pi kiwen leko loje",
  "block.minecraft.bricks": "kiwen leko loje",
  "block.minecraft.brown_banner": "len sitelen pi loje ma",
  "block.minecraft.brown_bed": "supa lape pi loje ma",
  "block.minecraft.brown_candle": "palisa suno lili pi loje ma",
  "block.minecraft.brown_candle_cake": "palisa suno lili pi loje ma lon pan suwi",
  "block.minecraft.brown_carpet": "len anpa pi loje ma",
  "block.minecraft.brown_concrete": "kiwen kule pi loje ma",
  "block.minecraft.brown_concrete_powder": "ko kule pi loje ma",
  "block.minecraft.brown_glazed_terracotta": "kiwen namako pi loje ma",
  "block.minecraft.brown_mushroom": "soko pi loje ma",
  "block.minecraft.brown_mushroom_block": "soko suli pi loje ma",
  "block.minecraft.brown_shulker_box": "poki pi loje ma pi monsuta Shulker",
  "block.minecraft.brown_stained_glass": "kiwen lukin pi loje ma",
  "block.minecraft.brown_stained_glass_pane": "sinpin lukin pi loje ma",
  "block.minecraft.brown_terracotta": "ma kiwen pi loje ma",
  "block.minecraft.brown_wool": "len pi loje ma",
  "block.minecraft.bubble_column": "sike kon",
  "block.minecraft.bubble_coral": "kiwen kala pi laso loje",
  "block.minecraft.bubble_coral_block": "kiwen kala suli pi laso loje",
  "block.minecraft.bubble_coral_fan": "lipu pi kiwen kala pi laso loje",
  "block.minecraft.bubble_coral_wall_fan": "lipu sinpin pi kiwen kala pi laso loje",
  "block.minecraft.budding_amethyst": "kiwen kalama mama",
  "block.minecraft.bush": "kasi anpa lili",
  "block.minecraft.cactus": "kasi kipisi",
  "block.minecraft.cactus_flower": "kasi suwi pi kasi kipisi",
  "block.minecraft.cake": "pan suwi",
  "block.minecraft.calcite": "kiwen walo ko",
  "block.minecraft.calibrated_sculk_sensor": "soko Sculk kute pi sona kalama",
  "block.minecraft.campfire": "seli palisa",
  "block.minecraft.candle": "palisa suno lili",
  "block.minecraft.candle_cake": "palisa suno lili lon pan suwi",
  "block.minecraft.carrots": "kili palisa",
  "block.minecraft.cartography_table": "supa pi sitelen ma",
  "block.minecraft.carved_pumpkin": "kili suli monsuta",
  "block.minecraft.cauldron": "poki suli",
  "block.minecraft.cave_air": "kon anpa",
  "block.minecraft.cave_vines": "kasi linja lupa",
  "block.minecraft.cave_vines_plant": "kasi linja lupa",
  "block.minecraft.chain": "linja kiwen",
  "block.minecraft.chain_command_block": "ilo pi toki wawa lon linja",
  "block.minecraft.cherry_button": "nena ilo pi kasi suwi",
  "block.minecraft.cherry_door": "lupa pi kasi suwi",
  "block.minecraft.cherry_fence": "sinpin palisa pi kasi suwi",
  "block.minecraft.cherry_fence_gate": "sinpin tawa pi kasi suwi",
  "block.minecraft.cherry_hanging_sign": "lipu sitelen sewi pi kasi suwi",
  "block.minecraft.cherry_leaves": "lipu pi kasi suwi",
  "block.minecraft.cherry_log": "sijelo pi kasi suwi",
  "block.minecraft.cherry_planks": "kiwen kipisi pi kasi suwi",
  "block.minecraft.cherry_pressure_plate": "supa noka pi kasi suwi",
  "block.minecraft.cherry_sapling": "kasi suwi sin",
  "block.minecraft.cherry_shelf": "poki sinpin pi kasi suwi",
  "block.minecraft.cherry_sign": "lipu sitelen pi kasi suwi",
  "block.minecraft.cherry_slab": "supa pi kasi suwi",
  "block.minecraft.cherry_stairs": "leko sewi pi kasi suwi",
  "block.minecraft.cherry_trapdoor": "lupa anpa pi kasi suwi",
  "block.minecraft.cherry_wall_hanging_sign": "lipu sitelen sewi pi kasi suwi",
  "block.minecraft.cherry_wall_sign": "lipu sitelen pi kasi suwi lon sinpin",
  "block.minecraft.cherry_wood": "kiwen pi kasi suwi",
  "block.minecraft.chest": "poki",
  "block.minecraft.chipped_anvil": "supa pona pi pakala lili",
  "block.minecraft.chiseled_bookshelf": "poki lipu",
  "block.minecraft.chiseled_copper": "kiwen ante sitelen",
  "block.minecraft.chiseled_deepslate": "kiwen anpa sitelen",
  "block.minecraft.chiseled_nether_bricks": "kiwen leko sitelen pi ma Nether",
  "block.minecraft.chiseled_polished_blackstone": "kiwen pimeja sitelen",
  "block.minecraft.chiseled_quartz_block": "kiwen walo sitelen",
  "block.minecraft.chiseled_red_sandstone": "kiwen ko loje sitelen",
  "block.minecraft.chiseled_resin_bricks": "kiwen leko sitelen pi kiwen ko loje",
  "block.minecraft.chiseled_sandstone": "kiwen ko sitelen",
  "block.minecraft.chiseled_stone_bricks": "kiwen leko sitelen",
  "block.minecraft.chiseled_tuff": "ko seli kiwen sitelen",
  "block.minecraft.chiseled_tuff_bricks": "ko seli kiwen leko sitelen",
  "block.minecraft.chorus_flower": "lawa pi kasi nasa",
  "block.minecraft.chorus_plant": "kasi nasa",
  "block.minecraft.clay": "ma ko",
  "block.minecraft.closed_eyeblossom": "kasi oko pini",
  "block.minecraft.coal_block": "leko pi ko pimeja",
  "block.minecraft.coal_ore": "ko pimeja pi insa kiwen",
  "block.minecraft.coarse_dirt": "ma pi kiwen lili",
  "block.minecraft.cobbled_deepslate": "kiwen anpa nena",
  "block.minecraft.cobbled_deepslate_slab": "supa pi kiwen anpa nena",
  "block.minecraft.cobbled_deepslate_stairs": "leko sewi pi kiwen anpa nena",
  "block.minecraft.cobbled_deepslate_wall": "sinpin pi kiwen anpa nena",
  "block.minecraft.cobblestone": "kiwen nena",
  "block.minecraft.cobblestone_slab": "supa pi kiwen nena",
  "block.minecraft.cobblestone_stairs": "leko sewi pi kiwen nena",
  "block.minecraft.cobblestone_wall": "sinpin pi kiwen nena",
  "block.minecraft.cobweb": "linja pipi",
  "block.minecraft.cocoa": "kili pi loje ma",
  "block.minecraft.command_block": "ilo pi toki wawa",
  "block.minecraft.comparator": "ilo pi ante wawa pi ko Redstone",
  "block.minecraft.composter": "poki jaki",
  "block.minecraft.conduit": "ilo wawa telo",
  "block.minecraft.copper_bars": "sinpin palisa pi kiwen ante",
  "block.minecraft.copper_block": "leko pi kiwen ante",
  "block.minecraft.copper_bulb": "suno ante",
  "block.minecraft.copper_chain": "linja pi kiwen ante",
  "block.minecraft.copper_chest": "poki kiwen",
  "block.minecraft.copper_door": "lupa pi kiwen ante",
  "block.minecraft.copper_golem_statue": "jan ilo poki kiwen",
  "block.minecraft.copper_grate": "kiwen ante lukin",
  "block.minecraft.copper_lantern": "poki suno pi kiwen ante",
  "block.minecraft.copper_ore": "kiwen ante pi insa kiwen",
  "block.minecraft.copper_torch": "palisa suno pi kiwen ante",
  "block.minecraft.copper_trapdoor": "lupa anpa pi kiwen ante",
  "block.minecraft.copper_wall_torch": "palisa suno sinpin pi kiwen ante",
  "block.minecraft.cornflower": "kasi pi laso telo",
  "block.minecraft.cracked_deepslate_bricks": "kiwen anpa leko pakala",
  "block.minecraft.cracked_deepslate_tiles": "kiwen anpa pi leko lipu pakala",
  "block.minecraft.cracked_nether_bricks": "kiwen leko pakala pi ma Nether",
  "block.minecraft.cracked_polished_blackstone_bricks": "kiwen pimeja leko pakala",
  "block.minecraft.cracked_stone_bricks": "kiwen leko pakala",
  "block.minecraft.crafter": "ilo pali",
  "block.minecraft.crafting_table": "supa pali",
  "block.minecraft.creaking_heart": "lawa pi monsuta kasi",
  "block.minecraft.creeper_head": "lawa pi monsuta Creeper",
  "block.minecraft.creeper_wall_head": "lawa pi monsuta Creeper lon sinpin",
  "block.minecraft.crimson_button": "nena ilo pi soko loje",
  "block.minecraft.crimson_door": "lupa pi soko loje",
  "block.minecraft.crimson_fence": "sinpin palisa pi soko loje",
  "block.minecraft.crimson_fence_gate": "sinpin tawa pi soko loje",
  "block.minecraft.crimson_fungus": "soko loje seli",
  "block.minecraft.crimson_hanging_sign": "lipu sitelen sewi pi soko loje",
  "block.minecraft.crimson_hyphae": "sijelo selo pi soko loje",
  "block.minecraft.crimson_nylium": "kiwen selo pi soko loje",
  "block.minecraft.crimson_planks": "kiwen kipisi pi soko loje",
  "block.minecraft.crimson_pressure_plate": "supa noka pi soko loje",
  "block.minecraft.crimson_roots": "noka kasi loje",
  "block.minecraft.crimson_shelf": "poki sinpin pi soko loje",
  "block.minecraft.crimson_sign": "lipu sitelen pi soko loje",
  "block.minecraft.crimson_slab": "supa pi soko loje",
  "block.minecraft.crimson_stairs": "leko sewi pi soko loje",
  "block.minecraft.crimson_stem": "sijelo pi soko loje",
  "block.minecraft.crimson_trapdoor": "lupa anpa pi soko loje",
  "block.minecraft.crimson_wall_hanging_sign": "lipu sitelen sewi pi soko loje lon sinpin",
  "block.minecraft.crimson_wall_sign": "lipu sitelen pi soko loje lon sinpin",
  "block.minecraft.crying_obsidian": "kiwen wawa pakala",
  "block.minecraft.cut_copper": "kiwen ante kipisi",
  "block.minecraft.cut_copper_slab": "supa pi kiwen ante",
  "block.minecraft.cut_copper_stairs": "leko sewi pi kiwen ante",
  "block.minecraft.cut_red_sandstone": "kiwen ko loje kipisi",
  "block.minecraft.cut_red_sandstone_slab": "supa pi kiwen ko loje kipisi",
  "block.minecraft.cut_sandstone": "kiwen ko kipisi",
  "block.minecraft.cut_sandstone_slab": "supa pi kiwen ko kipisi",
  "block.minecraft.cyan_banner": "len sitelen laso",
  "block.minecraft.cyan_bed": "supa lape laso",
  "block.minecraft.cyan_candle": "palisa suno lili laso",
  "block.minecraft.cyan_candle_cake": "palisa suno lili laso lon pan suwi",
  "block.minecraft.cyan_carpet": "len anpa laso",
  "block.minecraft.cyan_concrete": "kiwen kule laso",
  "block.minecraft.cyan_concrete_powder": "ko kule laso",
  "block.minecraft.cyan_glazed_terracotta": "kiwen namako laso",
  "block.minecraft.cyan_shulker_box": "poki laso pi monsuta Shulker",
  "block.minecraft.cyan_stained_glass": "kiwen lukin laso",
  "block.minecraft.cyan_stained_glass_pane": "sinpin lukin laso",
  "block.minecraft.cyan_terracotta": "ma kiwen laso",
  "block.minecraft.cyan_wool": "len laso",
  "block.minecraft.damaged_anvil": "supa pona pakala",
  "block.minecraft.dandelion": "kasi jelo",
  "block.minecraft.dark_oak_button": "nena ilo pi kasi pimeja",
  "block.minecraft.dark_oak_door": "lupa pi kasi pimeja",
  "block.minecraft.dark_oak_fence": "sinpin palisa pi kasi pimeja",
  "block.minecraft.dark_oak_fence_gate": "sinpin tawa pi kasi pimeja",
  "block.minecraft.dark_oak_hanging_sign": "lipu sitelen sewi pi kasi pimeja",
  "block.minecraft.dark_oak_leaves": "lipu pi kasi pimeja",
  "block.minecraft.dark_oak_log": "sijelo pi kasi pimeja",
  "block.minecraft.dark_oak_planks": "kiwen kipisi pi kasi pimeja",
  "block.minecraft.dark_oak_pressure_plate": "supa noka pi kasi pimeja",
  "block.minecraft.dark_oak_sapling": "kasi pimeja sin",
  "block.minecraft.dark_oak_shelf": "poki sinpin pi kasi pimeja",
  "block.minecraft.dark_oak_sign": "lipu sitelen pi kasi pimeja",
  "block.minecraft.dark_oak_slab": "supa pi kasi pimeja",
  "block.minecraft.dark_oak_stairs": "leko sewi pi kasi pimeja",
  "block.minecraft.dark_oak_trapdoor": "lupa anpa pi kasi pimeja",
  "block.minecraft.dark_oak_wall_hanging_sign": "lipu sitelen sewi pi kasi pimeja lon sinpin",
  "block.minecraft.dark_oak_wall_sign": "lipu sitelen pi kasi pimeja lon sinpin",
  "block.minecraft.dark_oak_wood": "kiwen pi kasi pimeja",
  "block.minecraft.dark_prismarine": "kiwen Prismarine pimeja",
  "block.minecraft.dark_prismarine_slab": "supa pi kiwen Prismarine pimeja",
  "block.minecraft.dark_prismarine_stairs": "leko sewi pi kiwen Prismarine pimeja",
  "block.minecraft.daylight_detector": "ilo lukin pi suno sewi",
  "block.minecraft.dead_brain_coral": "kiwen kala moli pi loje walo",
  "block.minecraft.dead_brain_coral_block": "kiwen kala suli moli pi loje walo",
  "block.minecraft.dead_brain_coral_fan": "lipu pi kiwen kala moli pi loje walo",
  "block.minecraft.dead_brain_coral_wall_fan": "lipu sinpin pi kiwen kala moli pi loje walo",
  "block.minecraft.dead_bubble_coral": "kiwen kala moli pi laso loje",
  "block.minecraft.dead_bubble_coral_block": "kiwen kala suli moli pi laso loje",
  "block.minecraft.dead_bubble_coral_fan": "lipu pi kiwen kala moli pi laso loje",
  "block.minecraft.dead_bubble_coral_wall_fan": "lipu sinpin pi kiwen kala moli pi laso loje",
  "block.minecraft.dead_bush": "kasi moli",
  "block.minecraft.dead_fire_coral": "kiwen kala loje moli",
  "block.minecraft.dead_fire_coral_block": "kiwen kala loje suli moli",
  "block.minecraft.dead_fire_coral_fan": "lipu pi kiwen kala loje moli",
  "block.minecraft.dead_fire_coral_wall_fan": "lipu sinpin pi kiwen kala loje moli",
  "block.minecraft.dead_horn_coral": "kiwen kala jelo moli",
  "block.minecraft.dead_horn_coral_block": "kiwen kala jelo suli moli",
  "block.minecraft.dead_horn_coral_fan": "lipu pi kiwen kala jelo moli",
  "block.minecraft.dead_horn_coral_wall_fan": "lipu sinpin pi kiwen kala jelo moli",
  "block.minecraft.dead_tube_coral": "kiwen kala laso moli",
  "block.minecraft.dead_tube_coral_block": "kiwen kala laso suli moli",
  "block.minecraft.dead_tube_coral_fan": "lipu pi kiwen kala laso moli",
  "block.minecraft.dead_tube_coral_wall_fan": "lipu sinpin pi kiwen kala laso moli",
  "block.minecraft.decorated_pot": "poki kiwen sitelen",
  "block.minecraft.deepslate": "kiwen anpa",
  "block.minecraft.deepslate_brick_slab": "supa pi kiwen anpa leko",
  "block.minecraft.deepslate_brick_stairs": "leko sewi pi kiwen anpa leko",
  "block.minecraft.deepslate_brick_wall": "sinpin pi kiwen anpa leko",
  "block.minecraft.deepslate_bricks": "kiwen anpa leko",
  "block.minecraft.deepslate_coal_ore": "ko pimeja pi kiwen anpa",
  "block.minecraft.deepslate_copper_ore": "kiwen ante pi kiwen anpa",
  "block.minecraft.deepslate_diamond_ore": "kiwen laso pi kiwen anpa",
  "block.minecraft.deepslate_emerald_ore": "kiwen esun pi kiwen anpa",
  "block.minecraft.deepslate_gold_ore": "kiwen jelo pi kiwen anpa",
  "block.minecraft.deepslate_iron_ore": "kiwen walo pi kiwen anpa",
  "block.minecraft.deepslate_lapis_ore": "kiwen pi laso telo pi kiwen anpa",
  "block.minecraft.deepslate_redstone_ore": "ko Redstone pi kiwen anpa",
  "block.minecraft.deepslate_tile_slab": "supa pi kiwen anpa pi leko lipu",
  "block.minecraft.deepslate_tile_stairs": "leko sewi pi kiwen anpa pi leko lipu",
  "block.minecraft.deepslate_tile_wall": "sinpin pi kiwen anpa pi leko lipu",
  "block.minecraft.deepslate_tiles": "kiwen anpa pi leko lipu",
  "block.minecraft.detector_rail": "nasin palisa lukin",
  "block.minecraft.diamond_block": "leko pi kiwen laso",
  "block.minecraft.diamond_ore": "kiwen laso pi insa kiwen",
  "block.minecraft.diorite": "kiwen walo pimeja",
  "block.minecraft.diorite_slab": "supa pi kiwen walo pimeja",
  "block.minecraft.diorite_stairs": "leko sewi pi kiwen walo pimeja",
  "block.minecraft.diorite_wall": "sinpin pi kiwen walo pimeja",
  "block.minecraft.dirt": "ma",
  "block.minecraft.dirt_path": "ma nasin",
  "block.minecraft.dispenser": "poki pi pana wawa",
  "block.minecraft.dragon_egg": "sike mama akesi",
  "block.minecraft.dragon_head": "lawa akesi",
  "block.minecraft.dragon_wall_head": "lawa akesi sinpin",
  "block.minecraft.dried_ghast": "kiwen Ghast pi telo ala",
  "block.minecraft.dried_kelp_block": "kulupu pi kasi telo",
  "block.minecraft.dripstone_block": "kiwen palisa",
  "block.minecraft.dropper": "poki pana",
  "block.minecraft.emerald_block": "leko pi kiwen esun",
  "block.minecraft.emerald_ore": "kiwen esun pi insa kiwen",
  "block.minecraft.enchanting_table": "supa wawa",
  "block.minecraft.end_gateway": "lupa weka pi ma End",
  "block.minecraft.end_portal": "lupa pi ma End",
  "block.minecraft.end_portal_frame": "selo lupa pi ma End",
  "block.minecraft.end_rod": "palisa pi ma End",
  "block.minecraft.end_stone": "kiwen pi ma End",
  "block.minecraft.end_stone_brick_slab": "supa kiwen pi ma End",
  "block.minecraft.end_stone_brick_stairs": "leko sewi pi ma End",
  "block.minecraft.end_stone_brick_wall": "sinpin kiwen pi ma End",
  "block.minecraft.end_stone_bricks": "kiwen leko pi ma End",
  "block.minecraft.ender_chest": "poki pi ma End",
  "block.minecraft.exposed_chiseled_copper": "kiwen ante sitelen pi loje ma",
  "block.minecraft.exposed_copper": "kiwen ante pi loje ma",
  "block.minecraft.exposed_copper_bars": "sinpin palisa pi kiwen ante pi loje ma",
  "block.minecraft.exposed_copper_bulb": "suno ante pi loje ma",
  "block.minecraft.exposed_copper_chain": "linja pi kiwen ante pi loje ma",
  "block.minecraft.exposed_copper_chest": "poki kiwen pi loje ma",
  "block.minecraft.exposed_copper_door": "lupa ante pi loje ma",
  "block.minecraft.exposed_copper_golem_statue": "jan ilo poki kiwen pi loje ma",
  "block.minecraft.exposed_copper_grate": "kiwen ante lukin pi loje ma",
  "block.minecraft.exposed_copper_lantern": "poki suno pi kiwen ante pi loje ma",
  "block.minecraft.exposed_copper_trapdoor": "lupa anpa ante pi loje ma",
  "block.minecraft.exposed_cut_copper": "kiwen ante kipisi pi loje ma",
  "block.minecraft.exposed_cut_copper_slab": "supa pi kiwen ante pi loje ma",
  "block.minecraft.exposed_cut_copper_stairs": "leko sewi pi kiwen ante pi loje ma",
  "block.minecraft.exposed_lightning_rod": "palisa pi linja wawa suno pi loje ma",
  "block.minecraft.farmland": "ma mama",
  "block.minecraft.fern": "kasi pi lipu waso",
  "block.minecraft.fire": "seli",
  "block.minecraft.fire_coral": "kiwen kala loje",
  "block.minecraft.fire_coral_block": "kiwen kala loje suli",
  "block.minecraft.fire_coral_fan": "lipu pi kiwen kala loje",
  "block.minecraft.fire_coral_wall_fan": "lipu sinpin pi kiwen kala loje",
  "block.minecraft.firefly_bush": "kasi anpa lili pi pipi suno",
  "block.minecraft.fletching_table": "supa pi palisa alasa",
  "block.minecraft.flower_pot": "poki kasi",
  "block.minecraft.flowering_azalea": "kasi kiwen lupa kule",
  "block.minecraft.flowering_azalea_leaves": "lipu kule pi kasi kiwen lupa",
  "block.minecraft.frogspawn": "sike mama pi akesi sewi lili",
  "block.minecraft.frosted_ice": "kiwen telo weka",
  "block.minecraft.furnace": "poki seli",
  "block.minecraft.gilded_blackstone": "kiwen pimeja mani",
  "block.minecraft.glass": "kiwen lukin",
  "block.minecraft.glass_pane": "sinpin lukin",
  "block.minecraft.glow_lichen": "kasi len suno",
  "block.minecraft.glowstone": "kiwen suno",
  "block.minecraft.gold_block": "leko pi kiwen jelo",
  "block.minecraft.gold_ore": "kiwen jelo pi insa kiwen",
  "block.minecraft.golden_dandelion": "kasi jelo mani",
  "block.minecraft.granite": "kiwen loje pimeja",
  "block.minecraft.granite_slab": "supa pi kiwen loje pimeja",
  "block.minecraft.granite_stairs": "leko sewi pi kiwen loje pimeja",
  "block.minecraft.granite_wall": "sinpin pi kiwen loje pimeja",
  "block.minecraft.grass": "kasi anpa",
  "block.minecraft.grass_block": "ma kasi",
  "block.minecraft.gravel": "kiwen lili mute",
  "block.minecraft.gray_banner": "len sitelen pi pimeja walo",
  "block.minecraft.gray_bed": "supa lape pi pimeja walo",
  "block.minecraft.gray_candle": "palisa suno lili pi pimeja walo",
  "block.minecraft.gray_candle_cake": "palisa suno lili pi pimeja walo lon pan suwi",
  "block.minecraft.gray_carpet": "len anpa pi pimeja walo",
  "block.minecraft.gray_concrete": "kiwen kule pi pimeja walo",
  "block.minecraft.gray_concrete_powder": "ko kule pi pimeja walo",
  "block.minecraft.gray_glazed_terracotta": "kiwen namako pi pimeja walo",
  "block.minecraft.gray_shulker_box": "poki pi pimeja walo pi monsuta Shulker",
  "block.minecraft.gray_stained_glass": "kiwen lukin pi pimeja walo",
  "block.minecraft.gray_stained_glass_pane": "sinpin lukin pi pimeja walo",
  "block.minecraft.gray_terracotta": "ma kiwen pi pimeja walo",
  "block.minecraft.gray_wool": "len pi pimeja walo",
  "block.minecraft.green_banner": "len sitelen pi laso kasi",
  "block.minecraft.green_bed": "supa lape pi laso kasi",
  "block.minecraft.green_candle": "palisa suno lili pi laso kasi",
  "block.minecraft.green_candle_cake": "palisa suno lili pi laso kasi lon pan suwi",
  "block.minecraft.green_carpet": "len anpa pi laso kasi",
  "block.minecraft.green_concrete": "kiwen kule pi laso kasi",
  "block.minecraft.green_concrete_powder": "ko kule pi laso kasi",
  "block.minecraft.green_glazed_terracotta": "kiwen namako pi laso kasi",
  "block.minecraft.green_shulker_box": "poki pi laso kasi pi monsuta Shulker",
  "block.minecraft.green_stained_glass": "kiwen lukin pi laso kasi",
  "block.minecraft.green_stained_glass_pane": "sinpin lukin pi laso kasi",
  "block.minecraft.green_terracotta": "ma kiwen pi laso kasi",
  "block.minecraft.green_wool": "len pi laso kasi",
  "block.minecraft.grindstone": "sike pi pona ilo",
  "block.minecraft.hanging_roots": "noka kasi",
  "block.minecraft.hay_block": "kulupu pan",
  "block.minecraft.heavy_core": "kiwen leko wawa",
  "block.minecraft.heavy_weighted_pressure_plate": "supa noka pi kiwen walo",
  "block.minecraft.honey_block": "leko pi suwi pipi",
  "block.minecraft.honeycomb_block": "lipu suwi suli",
  "block.minecraft.hopper": "poki pi tawa ijo",
  "block.minecraft.horn_coral": "kiwen kala jelo",
  "block.minecraft.horn_coral_block": "kiwen kala jelo suli",
  "block.minecraft.horn_coral_fan": "lipu pi kiwen kala jelo",
  "block.minecraft.horn_coral_wall_fan": "lipu sinpin pi kiwen kala jelo",
  "block.minecraft.ice": "kiwen telo",
  "block.minecraft.infested_chiseled_stone_bricks": "kiwen leko sitelen pipi",
  "block.minecraft.infested_cobblestone": "kiwen nena pipi",
  "block.minecraft.infested_cracked_stone_bricks": "kiwen leko pakala pipi",
  "block.minecraft.infested_deepslate": "kiwen anpa pipi",
  "block.minecraft.infested_mossy_stone_bricks": "kiwen leko kasi pipi",
  "block.minecraft.infested_stone": "kiwen pipi",
  "block.minecraft.infested_stone_bricks": "kiwen leko pipi",
  "block.minecraft.iron_bars": "sinpin palisa pi kiwen walo",
  "block.minecraft.iron_block": "leko pi kiwen walo",
  "block.minecraft.iron_chain": "linja pi kiwen walo",
  "block.minecraft.iron_door": "lupa pi kiwen walo",
  "block.minecraft.iron_ore": "kiwen walo pi insa kiwen",
  "block.minecraft.iron_trapdoor": "lupa anpa pi kiwen walo",
  "block.minecraft.jack_o_lantern": "kili suli suno",
  "block.minecraft.jigsaw": "leko pi ijo poka",
  "block.minecraft.jukebox": "ilo pi kalama musi",
  "block.minecraft.jungle_button": "nena ilo pi kasi suli",
  "block.minecraft.jungle_door": "lupa pi kasi suli",
  "block.minecraft.jungle_fence": "sinpin palisa pi kasi suli",
  "block.minecraft.jungle_fence_gate": "sinpin tawa pi kasi suli",
  "block.minecraft.jungle_hanging_sign": "lipu sitelen sewi pi kasi suli",
  "block.minecraft.jungle_leaves": "lipu pi kasi suli",
  "block.minecraft.jungle_log": "sijelo pi kasi suli",
  "block.minecraft.jungle_planks": "kiwen kipisi pi kasi suli",
  "block.minecraft.jungle_pressure_plate": "supa noka pi kasi suli",
  "block.minecraft.jungle_sapling": "kasi suli sin",
  "block.minecraft.jungle_shelf": "poki sinpin pi kasi suli",
  "block.minecraft.jungle_sign": "lipu sitelen pi kasi suli",
  "block.minecraft.jungle_slab": "supa pi kasi suli",
  "block.minecraft.jungle_stairs": "leko sewi pi kasi suli",
  "block.minecraft.jungle_trapdoor": "lupa anpa pi kasi suli",
  "block.minecraft.jungle_wall_hanging_sign": "lipu sitelen sewi pi kasi suli lon sinpin",
  "block.minecraft.jungle_wall_sign": "lipu sitelen pi kasi suli lon sinpin",
  "block.minecraft.jungle_wood": "kiwen pi kasi suli",
  "block.minecraft.kelp": "kasi linja telo",
  "block.minecraft.kelp_plant": "kasi linja telo",
  "block.minecraft.ladder": "nasin palisa sewi",
  "block.minecraft.lantern": "poki suno pi kiwen walo",
  "block.minecraft.lapis_block": "kiwen suli pi laso telo",
  "block.minecraft.lapis_ore": "kiwen pi laso telo pi insa kiwen",
  "block.minecraft.large_amethyst_bud": "kiwen kalama kama suli",
  "block.minecraft.large_fern": "kasi suli pi lipu waso",
  "block.minecraft.lava": "telo seli",
  "block.minecraft.lava_cauldron": "telo seli lon poki telo suli",
  "block.minecraft.leaf_litter": "kulupu anpa pi lipu kasi",
  "block.minecraft.lectern": "supa lipu",
  "block.minecraft.lever": "palisa ilo",
  "block.minecraft.light": "suno",
  "block.minecraft.light_blue_banner": "len sitelen pi laso sewi",
  "block.minecraft.light_blue_bed": "supa lape pi laso sewi",
  "block.minecraft.light_blue_candle": "palisa suno lili pi laso sewi",
  "block.minecraft.light_blue_candle_cake": "palisa suno lili pi laso sewi lon pan suwi",
  "block.minecraft.light_blue_carpet": "len anpa pi laso sewi",
  "block.minecraft.light_blue_concrete": "kiwen kule pi laso sewi",
  "block.minecraft.light_blue_concrete_powder": "ko kule pi laso sewi",
  "block.minecraft.light_blue_glazed_terracotta": "kiwen namako pi laso sewi",
  "block.minecraft.light_blue_shulker_box": "poki pi laso sewi pi monsuta Shulker",
  "block.minecraft.light_blue_stained_glass": "kiwen lukin pi laso sewi",
  "block.minecraft.light_blue_stained_glass_pane": "sinpin lukin pi laso sewi",
  "block.minecraft.light_blue_terracotta": "ma kiwen pi laso sewi",
  "block.minecraft.light_blue_wool": "len pi laso sewi",
  "block.minecraft.light_gray_banner": "len sitelen pi walo pimeja",
  "block.minecraft.light_gray_bed": "supa lape pi walo pimeja",
  "block.minecraft.light_gray_candle": "palisa suno lili pi walo pimeja",
  "block.minecraft.light_gray_candle_cake": "palisa suno lili pi walo pimeja lon pan suwi",
  "block.minecraft.light_gray_carpet": "len anpa pi walo pimeja",
  "block.minecraft.light_gray_concrete": "kiwen kule pi walo pimeja",
  "block.minecraft.light_gray_concrete_powder": "ko kule pi walo pimeja",
  "block.minecraft.light_gray_glazed_terracotta": "kiwen namako pi walo pimeja",
  "block.minecraft.light_gray_shulker_box": "poki pi walo pimeja pi monsuta Shulker",
  "block.minecraft.light_gray_stained_glass": "kiwen lukin pi walo pimeja",
  "block.minecraft.light_gray_stained_glass_pane": "sinpin lukin pi walo pimeja",
  "block.minecraft.light_gray_terracotta": "ma kiwen pi walo pimeja",
  "block.minecraft.light_gray_wool": "len pi walo pimeja",
  "block.minecraft.light_weighted_pressure_plate": "supa noka pi kiwen jelo",
  "block.minecraft.lightning_rod": "palisa pi linja wawa suno",
  "block.minecraft.lilac": "kasi suli pi loje laso",
  "block.minecraft.lily_of_the_valley": "kasi lili suwi",
  "block.minecraft.lily_pad": "kasi telo sike",
  "block.minecraft.lime_banner": "len sitelen pi laso jelo",
  "block.minecraft.lime_bed": "supa lape pi laso jelo",
  "block.minecraft.lime_candle": "palisa suno lili pi laso jelo",
  "block.minecraft.lime_candle_cake": "palisa suno lili pi laso jelo lon pan suwi",
  "block.minecraft.lime_carpet": "len anpa pi laso jelo",
  "block.minecraft.lime_concrete": "kiwen kule pi laso jelo",
  "block.minecraft.lime_concrete_powder": "ko kule pi laso jelo",
  "block.minecraft.lime_glazed_terracotta": "kiwen namako pi laso jelo",
  "block.minecraft.lime_shulker_box": "poki pi laso jelo pi monsuta Shulker",
  "block.minecraft.lime_stained_glass": "kiwen lukin pi laso jelo",
  "block.minecraft.lime_stained_glass_pane": "sinpin lukin pi laso jelo",
  "block.minecraft.lime_terracotta": "ma kiwen pi laso jelo",
  "block.minecraft.lime_wool": "len pi laso jelo",
  "block.minecraft.lodestone": "kiwen nasin",
  "block.minecraft.loom": "ilo len",
  "block.minecraft.magenta_banner": "len sitelen pi loje laso",
  "block.minecraft.magenta_bed": "supa lape pi loje laso",
  "block.minecraft.magenta_candle": "palisa suno lili pi loje laso",
  "block.minecraft.magenta_candle_cake": "palisa suno lili pi loje laso lon pan suwi",
  "block.minecraft.magenta_carpet": "len anpa pi loje laso",
  "block.minecraft.magenta_concrete": "kiwen kule pi loje laso",
  "block.minecraft.magenta_concrete_powder": "ko kule pi loje laso",
  "block.minecraft.magenta_glazed_terracotta": "kiwen namako pi loje laso",
  "block.minecraft.magenta_shulker_box": "poki pi loje laso pi monsuta Shulker",
  "block.minecraft.magenta_stained_glass": "kiwen lukin pi loje laso",
  "block.minecraft.magenta_stained_glass_pane": "sinpin lukin pi loje laso",
  "block.minecraft.magenta_terracotta": "ma kiwen pi loje laso",
  "block.minecraft.magenta_wool": "len pi loje laso",
  "block.minecraft.magma_block": "kiwen seli",
  "block.minecraft.mangrove_button": "nena ilo pi kasi telo",
  "block.minecraft.mangrove_door": "lupa pi kasi telo",
  "block.minecraft.mangrove_fence": "sinpin palisa pi kasi telo",
  "block.minecraft.mangrove_fence_gate": "sinpin tawa pi kasi telo",
  "block.minecraft.mangrove_hanging_sign": "lipu sitelen sewi pi kasi telo",
  "block.minecraft.mangrove_leaves": "lipu pi kasi telo",
  "block.minecraft.mangrove_log": "sijelo pi kasi telo",
  "block.minecraft.mangrove_planks": "kiwen kipisi pi kasi telo",
  "block.minecraft.mangrove_pressure_plate": "supa noka pi kasi telo",
  "block.minecraft.mangrove_propagule": "kasi kiwen telo sin",
  "block.minecraft.mangrove_roots": "noka pi kasi telo",
  "block.minecraft.mangrove_shelf": "poki sinpin pi kasi telo",
  "block.minecraft.mangrove_sign": "lipu sitelen pi kasi telo",
  "block.minecraft.mangrove_slab": "supa pi kasi telo",
  "block.minecraft.mangrove_stairs": "leko sewi pi kasi telo",
  "block.minecraft.mangrove_trapdoor": "lupa anpa pi kasi telo",
  "block.minecraft.mangrove_wall_hanging_sign": "lipu sitelen sewi pi kasi telo lon sinpin",
  "block.minecraft.mangrove_wall_sign": "lipu sitelen pi kasi telo lon sinpin",
  "block.minecraft.mangrove_wood": "kiwen pi kasi telo",
  "block.minecraft.medium_amethyst_bud": "kiwen kalama kama lili",
  "block.minecraft.melon": "kili suli laso",
  "block.minecraft.melon_stem": "kasi pi kili suli laso",
  "block.minecraft.moss_block": "leko pi len kasi",
  "block.minecraft.moss_carpet": "len anpa kasi",
  "block.minecraft.mossy_cobblestone": "kiwen nena kasi",
  "block.minecraft.mossy_cobblestone_slab": "supa pi kiwen nena kasi",
  "block.minecraft.mossy_cobblestone_stairs": "leko sewi pi kiwen nena kasi",
  "block.minecraft.mossy_cobblestone_wall": "sinpin pi kiwen nena kasi",
  "block.minecraft.mossy_stone_brick_slab": "supa pi kiwen leko kasi",
  "block.minecraft.mossy_stone_brick_stairs": "leko sewi pi kiwen leko kasi",
  "block.minecraft.mossy_stone_brick_wall": "sinpin pi kiwen leko kasi",
  "block.minecraft.mossy_stone_bricks": "kiwen leko kasi",
  "block.minecraft.moving_piston": "ilo tawa tawa",
  "block.minecraft.mud": "ma telo",
  "block.minecraft.mud_brick_slab": "supa pi kiwen leko ma",
  "block.minecraft.mud_brick_stairs": "leko sewi pi kiwen leko ma",
  "block.minecraft.mud_brick_wall": "sinpin pi kiwen leko ma",
  "block.minecraft.mud_bricks": "kiwen leko ma",
  "block.minecraft.muddy_mangrove_roots": "ma noka pi kasi telo",
  "block.minecraft.mushroom_stem": "sijelo soko",
  "block.minecraft.mycelium": "ma soko",
  "block.minecraft.nether_brick_fence": "sinpin palisa pi ma Nether",
  "block.minecraft.nether_brick_slab": "supa pi ma Nether",
  "block.minecraft.nether_brick_stairs": "leko sewi pi ma Nether",
  "block.minecraft.nether_brick_wall": "sinpin kiwen pi ma Nether",
  "block.minecraft.nether_bricks": "kiwen leko pi ma Nether",
  "block.minecraft.nether_gold_ore": "kiwen jelo pi kiwen pi ma Nether",
  "block.minecraft.nether_portal": "lupa nasa pi ma Nether",
  "block.minecraft.nether_quartz_ore": "kiwen walo pi kiwen pi ma Nether",
  "block.minecraft.nether_sprouts": "kasi lili pi ma Nether",
  "block.minecraft.nether_wart": "soko wawa pi ma Nether",
  "block.minecraft.nether_wart_block": "soko wawa suli pi ma Nether",
  "block.minecraft.netherite_block": "leko pi mani Netherite",
  "block.minecraft.netherrack": "kiwen Netherrack",
  "block.minecraft.note_block": "leko kalama",
  "block.minecraft.oak_button": "nena ilo pi kasi kili",
  "block.minecraft.oak_door": "lupa pi kasi kili",
  "block.minecraft.oak_fence": "sinpin palisa pi kasi kili",
  "block.minecraft.oak_fence_gate": "sinpin tawa pi kasi kili",
  "block.minecraft.oak_hanging_sign": "lipu sitelen sewi pi kasi kili",
  "block.minecraft.oak_leaves": "lipu pi kasi kili",
  "block.minecraft.oak_log": "sijelo pi kasi kili",
  "block.minecraft.oak_planks": "kiwen kipisi pi kasi kili",
  "block.minecraft.oak_pressure_plate": "supa noka pi kasi kili",
  "block.minecraft.oak_sapling": "kasi kili sin",
  "block.minecraft.oak_shelf": "poki sinpin pi kasi kili",
  "block.minecraft.oak_sign": "lipu sitelen pi kasi kili",
  "block.minecraft.oak_slab": "supa pi kasi kili",
  "block.minecraft.oak_stairs": "leko sewi pi kasi kili",
  "block.minecraft.oak_trapdoor": "lupa anpa pi kasi kili",
  "block.minecraft.oak_wall_hanging_sign": "lipu sitelen sewi pi kasi kili lon sinpin",
  "block.minecraft.oak_wall_sign": "lipu sitelen pi kasi kili lon sinpin",
  "block.minecraft.oak_wood": "kiwen pi kasi kili",
  "block.minecraft.observer": "ilo lukin wawa",
  "block.minecraft.obsidian": "kiwen pimeja wawa",
  "block.minecraft.ochre_froglight": "suno akesi jelo",
  "block.minecraft.ominous_banner": "len sitelen ike",
  "block.minecraft.open_eyeblossom": "kasi oko open",
  "block.minecraft.orange_banner": "len sitelen pi loje jelo",
  "block.minecraft.orange_bed": "supa lape pi loje jelo",
  "block.minecraft.orange_candle": "palisa suno lili pi loje jelo",
  "block.minecraft.orange_candle_cake": "palisa suno lili pi loje jelo lon pan suwi",
  "block.minecraft.orange_carpet": "len anpa pi loje jelo",
  "block.minecraft.orange_concrete": "kiwen kule pi loje jelo",
  "block.minecraft.orange_concrete_powder": "ko kule pi loje jelo",
  "block.minecraft.orange_glazed_terracotta": "kiwen namako pi loje jelo",
  "block.minecraft.orange_shulker_box": "poki pi loje jelo pi monsuta Shulker",
  "block.minecraft.orange_stained_glass": "kiwen lukin pi loje jelo",
  "block.minecraft.orange_stained_glass_pane": "sinpin lukin pi loje jelo",
  "block.minecraft.orange_terracotta": "ma kiwen pi loje jelo",
  "block.minecraft.orange_tulip": "kasi uta pi loje jelo",
  "block.minecraft.orange_wool": "len pi loje jelo",
  "block.minecraft.oxeye_daisy": "kasi pi walo pimeja",
  "block.minecraft.oxidized_chiseled_copper": "kiwen ante sitelen laso",
  "block.minecraft.oxidized_copper": "kiwen ante laso",
  "block.minecraft.oxidized_copper_bars": "sinpin palisa laso pi kiwen ante",
  "block.minecraft.oxidized_copper_bulb": "suno ante laso",
  "block.minecraft.oxidized_copper_chain": "linja laso pi kiwen ante",
  "block.minecraft.oxidized_copper_chest": "poki kiwen laso",
  "block.minecraft.oxidized_copper_door": "lupa ante laso",
  "block.minecraft.oxidized_copper_golem_statue": "jan ilo poki kiwen laso",
  "block.minecraft.oxidized_copper_grate": "kiwen ante lukin laso",
  "block.minecraft.oxidized_copper_lantern": "poki suno laso pi kiwen ante",
  "block.minecraft.oxidized_copper_trapdoor": "lupa anpa ante laso",
  "block.minecraft.oxidized_cut_copper": "kiwen ante kipisi laso",
  "block.minecraft.oxidized_cut_copper_slab": "supa pi kiwen ante laso",
  "block.minecraft.oxidized_cut_copper_stairs": "leko sewi pi kiwen ante laso",
  "block.minecraft.oxidized_lightning_rod": "palisa laso pi linja wawa suno",
  "block.minecraft.packed_ice": "kiwen telo kiwen",
  "block.minecraft.packed_mud": "ma telo kiwen",
  "block.minecraft.pale_hanging_moss": "kasi linja walo",
  "block.minecraft.pale_moss_block": "leko pi len kasi walo",
  "block.minecraft.pale_moss_carpet": "len anpa pi len kasi walo",
  "block.minecraft.pale_oak_button": "nena ilo pi kasi walo",
  "block.minecraft.pale_oak_door": "lupa pi kasi walo",
  "block.minecraft.pale_oak_fence": "sinpin palisa pi kasi walo",
  "block.minecraft.pale_oak_fence_gate": "sinpin tawa pi kasi walo",
  "block.minecraft.pale_oak_hanging_sign": "lipu sitelen sewi pi kasi walo",
  "block.minecraft.pale_oak_leaves": "lipu pi kasi walo",
  "block.minecraft.pale_oak_log": "sijelo pi kasi walo",
  "block.minecraft.pale_oak_planks": "kiwen kipisi pi kasi walo",
  "block.minecraft.pale_oak_pressure_plate": "supa noka pi kasi walo",
  "block.minecraft.pale_oak_sapling": "kasi walo sin",
  "block.minecraft.pale_oak_shelf": "poki sinpin pi kasi walo",
  "block.minecraft.pale_oak_sign": "lipu sitelen pi kasi walo",
  "block.minecraft.pale_oak_slab": "supa pi kasi walo",
  "block.minecraft.pale_oak_stairs": "leko sewi pi kasi walo",
  "block.minecraft.pale_oak_trapdoor": "lupa anpa pi kasi walo",
  "block.minecraft.pale_oak_wall_hanging_sign": "lipu sitelen sewi pi kasi walo lon sinpin",
  "block.minecraft.pale_oak_wall_sign": "lipu sitelen pi kasi walo lon sinpin",
  "block.minecraft.pale_oak_wood": "kiwen pi kasi walo",
  "block.minecraft.pearlescent_froglight": "suno akesi walo",
  "block.minecraft.peony": "kasi suli pi loje walo",
  "block.minecraft.petrified_oak_slab": "supa pi kasi kili moli",
  "block.minecraft.piglin_head": "lawa pi jan Piglin",
  "block.minecraft.piglin_wall_head": "lawa pi jan Piglin lon sinpin",
  "block.minecraft.pink_banner": "len sitelen pi loje walo",
  "block.minecraft.pink_bed": "supa lape pi loje walo",
  "block.minecraft.pink_candle": "palisa suno lili pi loje walo",
  "block.minecraft.pink_candle_cake": "palisa suno lili pi loje walo lon pan suwi",
  "block.minecraft.pink_carpet": "len anpa pi loje walo",
  "block.minecraft.pink_concrete": "kiwen kule pi loje walo",
  "block.minecraft.pink_concrete_powder": "ko kule pi loje walo",
  "block.minecraft.pink_glazed_terracotta": "kiwen namako pi loje walo",
  "block.minecraft.pink_petals": "lipu kule pi kasi suwi",
  "block.minecraft.pink_shulker_box": "poki pi loje walo pi monsuta Shulker",
  "block.minecraft.pink_stained_glass": "kiwen lukin pi loje walo",
  "block.minecraft.pink_stained_glass_pane": "sinpin lukin pi loje walo",
  "block.minecraft.pink_terracotta": "ma kiwen pi loje walo",
  "block.minecraft.pink_tulip": "kasi uta pi loje walo",
  "block.minecraft.pink_wool": "len pi loje walo",
  "block.minecraft.piston": "ilo tawa",
  "block.minecraft.piston_head": "luka pi ilo tawa",
  "block.minecraft.pitcher_crop": "kasi poki pi ma mama",
  "block.minecraft.pitcher_plant": "kasi poki",
  "block.minecraft.player_head": "lawa jan",
  "block.minecraft.player_head.named": "lawa %s",
  "block.minecraft.player_wall_head": "lawa jan lon sinpin",
  "block.minecraft.podzol": "ma kule",
  "block.minecraft.pointed_dripstone": "palisa kiwen",
  "block.minecraft.polished_andesite": "kiwen pimeja walo pi selo pona",
  "block.minecraft.polished_andesite_slab": "supa pi kiwen pimeja walo pi selo pona",
  "block.minecraft.polished_andesite_stairs": "leko sewi pi kiwen pimeja walo pi selo pona",
  "block.minecraft.polished_basalt": "kiwen palisa pimeja pi selo pona",
  "block.minecraft.polished_blackstone": "kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_brick_slab": "supa pi kiwen pimeja leko",
  "block.minecraft.polished_blackstone_brick_stairs": "leko sewi pi kiwen pimeja leko",
  "block.minecraft.polished_blackstone_brick_wall": "sinpin pi kiwen pimeja leko",
  "block.minecraft.polished_blackstone_bricks": "kiwen pimeja leko",
  "block.minecraft.polished_blackstone_button": "nena ilo pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_pressure_plate": "supa noka pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_slab": "supa pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_stairs": "leko sewi pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_blackstone_wall": "sinpin pi kiwen pimeja pi selo pona",
  "block.minecraft.polished_deepslate": "kiwen anpa pi selo pona",
  "block.minecraft.polished_deepslate_slab": "supa pi kiwen anpa pi selo pona",
  "block.minecraft.polished_deepslate_stairs": "leko sewi pi kiwen anpa pi selo pona",
  "block.minecraft.polished_deepslate_wall": "sinpin pi kiwen anpa pi selo pona",
  "block.minecraft.polished_diorite": "kiwen walo pimeja pi selo pona",
  "block.minecraft.polished_diorite_slab": "supa pi kiwen walo pimeja pi selo pona",
  "block.minecraft.polished_diorite_stairs": "leko sewi pi kiwen walo pimeja pi selo pona",
  "block.minecraft.polished_granite": "kiwen loje pimeja pi selo pona",
  "block.minecraft.polished_granite_slab": "supa pi kiwen loje pimeja pi selo pona",
  "block.minecraft.polished_granite_stairs": "leko sewi pi kiwen loje pimeja pi selo pona",
  "block.minecraft.polished_tuff": "ko seli kiwen pi selo pona",
  "block.minecraft.polished_tuff_slab": "supa pi ko seli kiwen pi selo pona",
  "block.minecraft.polished_tuff_stairs": "leko sewi pi ko seli kiwen pi selo pona",
  "block.minecraft.polished_tuff_wall": "sinpin pi ko seli kiwen pi selo pona",
  "block.minecraft.poppy": "kasi loje",
  "block.minecraft.potatoes": "kili ma",
  "block.minecraft.potted_acacia_sapling": "kasi seli lon poki",
  "block.minecraft.potted_allium": "kasi pi laso loje lon poki",
  "block.minecraft.potted_azalea_bush": "kasi lupa lon poki",
  "block.minecraft.potted_azure_bluet": "kasi walo lili lon poki",
  "block.minecraft.potted_bamboo": "kasi palisa lon poki",
  "block.minecraft.potted_birch_sapling": "kasi jelo lon poki",
  "block.minecraft.potted_blue_orchid": "kasi pi laso sewi lon poki",
  "block.minecraft.potted_brown_mushroom": "soko pi loje ma lon poki",
  "block.minecraft.potted_cactus": "kasi kipisi lon poki",
  "block.minecraft.potted_cherry_sapling": "kasi suwi lon poki",
  "block.minecraft.potted_closed_eyeblossom": "kasi oko pini lon poki",
  "block.minecraft.potted_cornflower": "kasi laso lon poki",
  "block.minecraft.potted_crimson_fungus": "soko loje seli lon poki",
  "block.minecraft.potted_crimson_roots": "noka kasi loje lon poki",
  "block.minecraft.potted_dandelion": "kasi jelo lon poki",
  "block.minecraft.potted_dark_oak_sapling": "kasi pimeja lon poki",
  "block.minecraft.potted_dead_bush": "kasi moli lon poki",
  "block.minecraft.potted_fern": "kasi pi lipu waso lon poki",
  "block.minecraft.potted_flowering_azalea_bush": "kasi lupa kule lon poki",
  "block.minecraft.potted_golden_dandelion": "kasi jelo mani lon poki",
  "block.minecraft.potted_jungle_sapling": "kasi suli lon poki",
  "block.minecraft.potted_lily_of_the_valley": "kasi lili suwi lon poki",
  "block.minecraft.potted_mangrove_propagule": "kasi kiwen telo sin lon poki",
  "block.minecraft.potted_oak_sapling": "kasi kili lon poki",
  "block.minecraft.potted_open_eyeblossom": "kasi oko open lon poki",
  "block.minecraft.potted_orange_tulip": "kasi uta pi loje jelo lon poki",
  "block.minecraft.potted_oxeye_daisy": "kasi pi walo pimeja lon poki",
  "block.minecraft.potted_pale_oak_sapling": "kasi walo lon poki",
  "block.minecraft.potted_pink_tulip": "kasi uta pi loje walo lon poki",
  "block.minecraft.potted_poppy": "kasi loje lon poki",
  "block.minecraft.potted_red_mushroom": "soko loje walo lon poki",
  "block.minecraft.potted_red_tulip": "kasi uta loje lon poki",
  "block.minecraft.potted_spruce_sapling": "kasi lete lon poki",
  "block.minecraft.potted_torchflower": "kasi seli lon poki",
  "block.minecraft.potted_warped_fungus": "soko laso lon poki",
  "block.minecraft.potted_warped_roots": "noka kasi laso lon poki",
  "block.minecraft.potted_white_tulip": "kasi uta walo lon poki",
  "block.minecraft.potted_wither_rose": "kasi moli Wither lon poki",
  "block.minecraft.powder_snow": "ko lete kon",
  "block.minecraft.powder_snow_cauldron": "ko lete kon lon poki telo suli",
  "block.minecraft.powered_rail": "nasin palisa wawa",
  "block.minecraft.prismarine": "kiwen Prismarine",
  "block.minecraft.prismarine_brick_slab": "supa pi kiwen leko Prismarine",
  "block.minecraft.prismarine_brick_stairs": "leko sewi pi kiwen leko Prismarine",
  "block.minecraft.prismarine_bricks": "kiwen leko Prismarine",
  "block.minecraft.prismarine_slab": "supa pi kiwen Prismarine",
  "block.minecraft.prismarine_stairs": "leko sewi pi kiwen Prismarine",
  "block.minecraft.prismarine_wall": "sinpin pi kiwen Prismarine",
  "block.minecraft.pumpkin": "kili suli jelo",
  "block.minecraft.pumpkin_stem": "kasi pi kili suli jelo",
  "block.minecraft.purple_banner": "len sitelen pi laso loje",
  "block.minecraft.purple_bed": "supa lape pi laso loje",
  "block.minecraft.purple_candle": "palisa suno lili pi laso loje",
  "block.minecraft.purple_candle_cake": "palisa suno lili pi laso loje lon pan suwi",
  "block.minecraft.purple_carpet": "len anpa pi laso loje",
  "block.minecraft.purple_concrete": "kiwen kule pi laso loje",
  "block.minecraft.purple_concrete_powder": "ko kule pi laso loje",
  "block.minecraft.purple_glazed_terracotta": "kiwen namako pi laso loje",
  "block.minecraft.purple_shulker_box": "poki pi laso loje pi monsuta Shulker",
  "block.minecraft.purple_stained_glass": "kiwen lukin pi laso loje",
  "block.minecraft.purple_stained_glass_pane": "sinpin lukin pi laso loje",
  "block.minecraft.purple_terracotta": "ma kiwen pi laso loje",
  "block.minecraft.purple_wool": "len pi laso loje",
  "block.minecraft.purpur_block": "kiwen Purpur",
  "block.minecraft.purpur_pillar": "kiwen Purpur palisa",
  "block.minecraft.purpur_slab": "supa pi kiwen Purpur",
  "block.minecraft.purpur_stairs": "leko sewi pi kiwen Purpur",
  "block.minecraft.quartz_block": "leko pi kiwen walo pi ma seli",
  "block.minecraft.quartz_bricks": "kiwen walo leko",
  "block.minecraft.quartz_pillar": "kiwen walo palisa",
  "block.minecraft.quartz_slab": "supa pi kiwen walo",
  "block.minecraft.quartz_stairs": "leko sewi pi kiwen walo",
  "block.minecraft.rail": "nasin palisa",
  "block.minecraft.raw_copper_block": "leko pi kiwen ante lete",
  "block.minecraft.raw_gold_block": "leko pi kiwen jelo lete",
  "block.minecraft.raw_iron_block": "leko pi kiwen walo lete",
  "block.minecraft.red_banner": "len sitelen loje",
  "block.minecraft.red_bed": "supa lape loje",
  "block.minecraft.red_candle": "palisa suno lili loje",
  "block.minecraft.red_candle_cake": "palisa suno lili loje lon pan suwi",
  "block.minecraft.red_carpet": "len anpa loje",
  "block.minecraft.red_concrete": "kiwen kule loje",
  "block.minecraft.red_concrete_powder": "ko kule loje",
  "block.minecraft.red_glazed_terracotta": "kiwen namako loje",
  "block.minecraft.red_mushroom": "soko loje walo",
  "block.minecraft.red_mushroom_block": "soko suli loje walo",
  "block.minecraft.red_nether_brick_slab": "supa pi kiwen leko loje pi ma Nether",
  "block.minecraft.red_nether_brick_stairs": "leko sewi pi kiwen leko loje pi ma Nether",
  "block.minecraft.red_nether_brick_wall": "sinpin pi kiwen leko loje pi ma Nether",
  "block.minecraft.red_nether_bricks": "kiwen leko loje pi ma Nether",
  "block.minecraft.red_sand": "ko loje",
  "block.minecraft.red_sandstone": "kiwen ko loje",
  "block.minecraft.red_sandstone_slab": "supa pi kiwen ko loje",
  "block.minecraft.red_sandstone_stairs": "leko sewi pi kiwen ko loje",
  "block.minecraft.red_sandstone_wall": "sinpin pi kiwen ko loje",
  "block.minecraft.red_shulker_box": "poki loje pi monsuta Shulker",
  "block.minecraft.red_stained_glass": "kiwen lukin loje",
  "block.minecraft.red_stained_glass_pane": "sinpin lukin loje",
  "block.minecraft.red_terracotta": "ma kiwen loje",
  "block.minecraft.red_tulip": "kasi uta loje",
  "block.minecraft.red_wool": "len loje",
  "block.minecraft.redstone_block": "leko pi ko Redstone",
  "block.minecraft.redstone_lamp": "suno pi ko Redstone",
  "block.minecraft.redstone_ore": "ko Redstone pi insa kiwen",
  "block.minecraft.redstone_torch": "palisa suno pi ko Redstone",
  "block.minecraft.redstone_wall_torch": "palisa suno sinpin pi ko Redstone",
  "block.minecraft.redstone_wire": "linja pi ko Redstone",
  "block.minecraft.reinforced_deepslate": "kiwen anpa wawa",
  "block.minecraft.repeater": "ilo pi tenpo wawa pi ko Redstone",
  "block.minecraft.repeating_command_block": "ilo pi toki wawa lon sike",
  "block.minecraft.resin_block": "leko pi kiwen ko loje",
  "block.minecraft.resin_brick_slab": "supa pi kiwen ko loje",
  "block.minecraft.resin_brick_stairs": "leko sewi pi kiwen ko loje",
  "block.minecraft.resin_brick_wall": "sinpin kiwen pi kiwen ko loje",
  "block.minecraft.resin_bricks": "kiwen leko pi kiwen ko loje",
  "block.minecraft.resin_clump": "kulupu pi kiwen ko loje",
  "block.minecraft.respawn_anchor": "ilo pi kama sin",
  "block.minecraft.rooted_dirt": "ma pi noka kasi",
  "block.minecraft.rose_bush": "kasi loje suwi",
  "block.minecraft.sand": "ko",
  "block.minecraft.sandstone": "kiwen ko",
  "block.minecraft.sandstone_slab": "supa pi kiwen ko",
  "block.minecraft.sandstone_stairs": "leko sewi pi kiwen ko",
  "block.minecraft.sandstone_wall": "sinpin pi kiwen ko",
  "block.minecraft.scaffolding": "supa palisa",
  "block.minecraft.sculk": "soko Sculk",
  "block.minecraft.sculk_catalyst": "soko Sculk mama",
  "block.minecraft.sculk_sensor": "soko Sculk kute",
  "block.minecraft.sculk_shrieker": "soko Sculk kalama",
  "block.minecraft.sculk_vein": "len pi soko Sculk",
  "block.minecraft.sea_lantern": "suno telo",
  "block.minecraft.sea_pickle": "kili telo",
  "block.minecraft.seagrass": "kasi telo",
  "block.minecraft.set_spawn": "ma ni la sina kama sin",
  "block.minecraft.short_dry_grass": "kasi anpa pi telo ala",
  "block.minecraft.short_grass": "kasi anpa",
  "block.minecraft.shroomlight": "suno soko",
  "block.minecraft.shulker_box": "poki pi monsuta Shulker",
  "block.minecraft.skeleton_skull": "lawa pi jan moli palisa",
  "block.minecraft.skeleton_wall_skull": "lawa pi jan moli palisa lon sinpin",
  "block.minecraft.slime_block": "ko monsuta suli",
  "block.minecraft.small_amethyst_bud": "kiwen kalama kama sin",
  "block.minecraft.small_dripleaf": "kasi supa lili",
  "block.minecraft.smithing_table": "supa ilo",
  "block.minecraft.smoker": "poki pi seli moku",
  "block.minecraft.smooth_basalt": "kiwen pi seli lete pi selo pona",
  "block.minecraft.smooth_quartz": "kiwen walo suli pi selo pona",
  "block.minecraft.smooth_quartz_slab": "supa pi kiwen walo pi selo pona",
  "block.minecraft.smooth_quartz_stairs": "leko sewi pi kiwen walo pi selo pona",
  "block.minecraft.smooth_red_sandstone": "kiwen ko loje pi selo pona",
  "block.minecraft.smooth_red_sandstone_slab": "supa pi kiwen ko loje pi selo pona",
  "block.minecraft.smooth_red_sandstone_stairs": "leko sewi pi kiwen ko loje pi selo pona",
  "block.minecraft.smooth_sandstone": "kiwen ko pi selo pona",
  "block.minecraft.smooth_sandstone_slab": "supa pi kiwen ko pi selo pona",
  "block.minecraft.smooth_sandstone_stairs": "leko sewi pi kiwen ko pi selo pona",
  "block.minecraft.smooth_stone": "kiwen pi selo pona",
  "block.minecraft.smooth_stone_slab": "supa kiwen pi selo pona",
  "block.minecraft.sniffer_egg": "sike mama pi soweli suli alasa",
  "block.minecraft.snow": "ko lete",
  "block.minecraft.snow_block": "ko lete suli",
  "block.minecraft.soul_campfire": "seli palisa kon",
  "block.minecraft.soul_fire": "seli kon",
  "block.minecraft.soul_lantern": "poki suno kon pi kiwen walo",
  "block.minecraft.soul_sand": "ko kon",
  "block.minecraft.soul_soil": "ma kon",
  "block.minecraft.soul_torch": "palisa suno kon",
  "block.minecraft.soul_wall_torch": "palisa suno sinpin kon",
  "block.minecraft.spawn.not_valid": "sina jo ala e supa lape e ilo pi kama sin. ken la ona li pakala",
  "block.minecraft.spawner": "ilo kama",
  "block.minecraft.spawner.desc1": "sina kepeken sike mama la:",
  "block.minecraft.spawner.desc2": "ni li ante e soweli/monsuta",
  "block.minecraft.sponge": "ko pi weka telo",
  "block.minecraft.spore_blossom": "kasi kule pana",
  "block.minecraft.spruce_button": "nena ilo pi kasi lete",
  "block.minecraft.spruce_door": "lupa pi kasi lete",
  "block.minecraft.spruce_fence": "sinpin palisa pi kasi lete",
  "block.minecraft.spruce_fence_gate": "sinpin tawa pi kasi lete",
  "block.minecraft.spruce_hanging_sign": "lipu sitelen sewi pi kasi lete",
  "block.minecraft.spruce_leaves": "lipu pi kasi lete",
  "block.minecraft.spruce_log": "sijelo pi kasi lete",
  "block.minecraft.spruce_planks": "kiwen kipisi pi kasi lete",
  "block.minecraft.spruce_pressure_plate": "supa noka pi kasi lete",
  "block.minecraft.spruce_sapling": "kasi lete sin",
  "block.minecraft.spruce_shelf": "poki sinpin pi kasi lete",
  "block.minecraft.spruce_sign": "lipu sitelen pi kasi lete",
  "block.minecraft.spruce_slab": "supa pi kasi lete",
  "block.minecraft.spruce_stairs": "leko sewi pi kasi lete",
  "block.minecraft.spruce_trapdoor": "lupa anpa pi kasi lete",
  "block.minecraft.spruce_wall_hanging_sign": "lipu sitelen sewi pi kasi lete lon sinpin",
  "block.minecraft.spruce_wall_sign": "lipu sitelen pi kasi lete lon sinpin",
  "block.minecraft.spruce_wood": "kiwen pi kasi lete",
  "block.minecraft.sticky_piston": "ilo tawa ko",
  "block.minecraft.stone": "kiwen",
  "block.minecraft.stone_brick_slab": "supa pi kiwen leko",
  "block.minecraft.stone_brick_stairs": "leko sewi pi kiwen leko",
  "block.minecraft.stone_brick_wall": "sinpin pi kiwen leko",
  "block.minecraft.stone_bricks": "kiwen leko",
  "block.minecraft.stone_button": "nena ilo kiwen",
  "block.minecraft.stone_pressure_plate": "supa noka kiwen",
  "block.minecraft.stone_slab": "supa kiwen",
  "block.minecraft.stone_stairs": "leko sewi kiwen",
  "block.minecraft.stonecutter": "sike pi kipisi kiwen",
  "block.minecraft.stripped_acacia_log": "sijelo pi kasi seli pi selo weka",
  "block.minecraft.stripped_acacia_wood": "kiwen pi kasi seli pi selo weka",
  "block.minecraft.stripped_bamboo_block": "sijelo pi leko kasi palisa",
  "block.minecraft.stripped_birch_log": "sijelo pi kasi jelo pi selo weka",
  "block.minecraft.stripped_birch_wood": "kiwen pi kasi jelo pi selo weka",
  "block.minecraft.stripped_cherry_log": "sijelo pi kasi suwi pi selo weka",
  "block.minecraft.stripped_cherry_wood": "kiwen pi kasi suwi pi selo weka",
  "block.minecraft.stripped_crimson_hyphae": "sijelo selo pi soko loje pi selo weka",
  "block.minecraft.stripped_crimson_stem": "sijelo pi soko loje pi selo weka",
  "block.minecraft.stripped_dark_oak_log": "sijelo pi kasi pimeja pi selo weka",
  "block.minecraft.stripped_dark_oak_wood": "kiwen pi kasi pimeja pi selo weka",
  "block.minecraft.stripped_jungle_log": "sijelo pi kasi suli pi selo weka",
  "block.minecraft.stripped_jungle_wood": "kiwen pi kasi suli pi selo weka",
  "block.minecraft.stripped_mangrove_log": "sijelo pi kasi telo pi selo weka",
  "block.minecraft.stripped_mangrove_wood": "kiwen pi kasi telo pi selo weka",
  "block.minecraft.stripped_oak_log": "sijelo pi kasi kili pi selo weka",
  "block.minecraft.stripped_oak_wood": "kiwen pi kasi kili pi selo weka",
  "block.minecraft.stripped_pale_oak_log": "sijelo pi kasi walo pi selo weka",
  "block.minecraft.stripped_pale_oak_wood": "kiwen pi kasi walo pi selo weka",
  "block.minecraft.stripped_spruce_log": "sijelo pi kasi lete pi selo weka",
  "block.minecraft.stripped_spruce_wood": "kiwen pi kasi lete pi selo weka",
  "block.minecraft.stripped_warped_hyphae": "sijelo selo pi soko laso pi selo weka",
  "block.minecraft.stripped_warped_stem": "sijelo pi soko laso pi selo weka",
  "block.minecraft.structure_block": "ilo pi pali tomo",
  "block.minecraft.structure_void": "ala pi pali tomo",
  "block.minecraft.sugar_cane": "kasi palisa suwi",
  "block.minecraft.sunflower": "kasi suno",
  "block.minecraft.suspicious_gravel": "kiwen lili mute nasa",
  "block.minecraft.suspicious_sand": "ko nasa",
  "block.minecraft.sweet_berry_bush": "kasi pi kili suwi",
  "block.minecraft.tall_dry_grass": "kasi suli pi telo ala",
  "block.minecraft.tall_grass": "kasi anpa suli",
  "block.minecraft.tall_seagrass": "kasi telo suli",
  "block.minecraft.target": "sike pi alasa musi",
  "block.minecraft.terracotta": "ma kiwen",
  "block.minecraft.test_block": "leko alasa",
  "block.minecraft.test_instance_block": "poki pi leko alasa",
  "block.minecraft.tinted_glass": "kiwen lukin pi awen suno",
  "block.minecraft.tnt": "ilo pi seli pakala",
  "block.minecraft.tnt.disabled": "pakala li tan ilo pi seli pakala la ona li ken ala",
  "block.minecraft.torch": "palisa suno",
  "block.minecraft.torchflower": "kasi seli",
  "block.minecraft.torchflower_crop": "kasi seli pi ma mama",
  "block.minecraft.trapped_chest": "poki lukin",
  "block.minecraft.trial_spawner": "ilo kama pi tomo alasa",
  "block.minecraft.tripwire": "linja noka",
  "block.minecraft.tripwire_hook": "ilo pi linja noka",
  "block.minecraft.tube_coral": "kiwen kala laso",
  "block.minecraft.tube_coral_block": "kiwen kala laso suli",
  "block.minecraft.tube_coral_fan": "lipu pi kiwen kala laso",
  "block.minecraft.tube_coral_wall_fan": "lipu sinpin pi kiwen kala laso",
  "block.minecraft.tuff": "ko seli kiwen",
  "block.minecraft.tuff_brick_slab": "supa pi ko seli kiwen leko",
  "block.minecraft.tuff_brick_stairs": "leko sewi pi ko seli kiwen leko",
  "block.minecraft.tuff_brick_wall": "sinpin pi ko seli kiwen leko",
  "block.minecraft.tuff_bricks": "ko seli kiwen leko",
  "block.minecraft.tuff_slab": "supa pi ko seli kiwen",
  "block.minecraft.tuff_stairs": "leko sewi pi ko seli kiwen",
  "block.minecraft.tuff_wall": "sinpin pi ko seli kiwen",
  "block.minecraft.turtle_egg": "sike mama pi akesi tomo",
  "block.minecraft.twisting_vines": "kasi linja laso",
  "block.minecraft.twisting_vines_plant": "kasi linja laso",
  "block.minecraft.vault": "poki mani",
  "block.minecraft.verdant_froglight": "suno akesi laso",
  "block.minecraft.vine": "kasi linja",
  "block.minecraft.void_air": "kon pimeja",
  "block.minecraft.wall_torch": "palisa suno sinpin lon",
  "block.minecraft.warped_button": "nena ilo pi soko laso",
  "block.minecraft.warped_door": "lupa pi soko laso",
  "block.minecraft.warped_fence": "sinpin palisa pi soko laso",
  "block.minecraft.warped_fence_gate": "sinpin tawa pi soko laso",
  "block.minecraft.warped_fungus": "soko laso",
  "block.minecraft.warped_hanging_sign": "lipu sitelen sewi pi soko laso",
  "block.minecraft.warped_hyphae": "sijelo selo pi soko laso",
  "block.minecraft.warped_nylium": "kiwen selo pi soko laso",
  "block.minecraft.warped_planks": "kiwen kipisi pi soko laso",
  "block.minecraft.warped_pressure_plate": "supa noka pi soko laso",
  "block.minecraft.warped_roots": "noka kasi laso",
  "block.minecraft.warped_shelf": "poki sinpin pi soko laso",
  "block.minecraft.warped_sign": "lipu sitelen pi soko laso",
  "block.minecraft.warped_slab": "supa pi soko laso",
  "block.minecraft.warped_stairs": "leko sewi pi soko laso",
  "block.minecraft.warped_stem": "sijelo pi soko laso",
  "block.minecraft.warped_trapdoor": "lupa anpa pi soko laso",
  "block.minecraft.warped_wall_hanging_sign": "lipu sitelen sewi pi soko laso lon sinpin",
  "block.minecraft.warped_wall_sign": "lipu sitelen pi soko laso lon sinpin",
  "block.minecraft.warped_wart_block": "soko laso suli",
  "block.minecraft.water": "telo",
  "block.minecraft.water_cauldron": "telo lon poki telo suli",
  "block.minecraft.waxed_chiseled_copper": "kiwen ante sitelen awen",
  "block.minecraft.waxed_copper_bars": "sinpin palisa awen pi kiwen ante",
  "block.minecraft.waxed_copper_block": "leko pi kiwen ante awen",
  "block.minecraft.waxed_copper_bulb": "suno ante awen",
  "block.minecraft.waxed_copper_chain": "linja awen pi kiwen ante",
  "block.minecraft.waxed_copper_chest": "poki kiwen awen",
  "block.minecraft.waxed_copper_door": "lupa ante awen",
  "block.minecraft.waxed_copper_golem_statue": "jan ilo poki kiwen awen",
  "block.minecraft.waxed_copper_grate": "kiwen ante lukin awen",
  "block.minecraft.waxed_copper_lantern": "poki suno awen pi kiwen ante",
  "block.minecraft.waxed_copper_trapdoor": "lupa anpa ante awen",
  "block.minecraft.waxed_cut_copper": "kiwen ante kipisi awen",
  "block.minecraft.waxed_cut_copper_slab": "supa pi kiwen ante awen",
  "block.minecraft.waxed_cut_copper_stairs": "leko sewi awen pi kiwen ante",
  "block.minecraft.waxed_exposed_chiseled_copper": "kiwen ante sitelen awen pi loje ma",
  "block.minecraft.waxed_exposed_copper": "kiwen ante awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_bars": "sinpin palisa awen pi kiwen ante pi loje ma",
  "block.minecraft.waxed_exposed_copper_bulb": "suno ante awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_chain": "linja awen pi kiwen ante pi loje ma",
  "block.minecraft.waxed_exposed_copper_chest": "poki kiwen awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_door": "lupa ante awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_golem_statue": "jan ilo poki kiwen awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_grate": "kiwen ante lukin awen pi loje ma",
  "block.minecraft.waxed_exposed_copper_lantern": "poki suno awen pi kiwen ante pi loje ma",
  "block.minecraft.waxed_exposed_copper_trapdoor": "lupa anpa ante awen pi loje ma",
  "block.minecraft.waxed_exposed_cut_copper": "kiwen ante kipisi awen pi loje ma",
  "block.minecraft.waxed_exposed_cut_copper_slab": "supa pi kiwen ante awen pi loje ma",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "leko sewi awen pi kiwen ante pi loje ma",
  "block.minecraft.waxed_exposed_lightning_rod": "palisa awen pi linja wawa suno pi loje ma",
  "block.minecraft.waxed_lightning_rod": "palisa awen pi linja wawa suno",
  "block.minecraft.waxed_oxidized_chiseled_copper": "kiwen ante sitelen awen laso",
  "block.minecraft.waxed_oxidized_copper": "kiwen ante awen laso",
  "block.minecraft.waxed_oxidized_copper_bars": "sinpin palisa laso pi kiwen ante",
  "block.minecraft.waxed_oxidized_copper_bulb": "suno ante awen laso",
  "block.minecraft.waxed_oxidized_copper_chain": "linja laso pi kiwen ante",
  "block.minecraft.waxed_oxidized_copper_chest": "poki kiwen awen laso",
  "block.minecraft.waxed_oxidized_copper_door": "lupa ante awen laso",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "jan ilo poki kiwen awen laso",
  "block.minecraft.waxed_oxidized_copper_grate": "kiwen ante lukin awen laso",
  "block.minecraft.waxed_oxidized_copper_lantern": "poki suno laso pi kiwen ante",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "lupa anpa ante awen laso",
  "block.minecraft.waxed_oxidized_cut_copper": "kiwen ante kipisi awen laso",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "supa pi kiwen ante awen laso",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "leko sewi awen pi kiwen ante laso",
  "block.minecraft.waxed_oxidized_lightning_rod": "palisa awen laso pi linja wawa suno",
  "block.minecraft.waxed_weathered_chiseled_copper": "kiwen ante sitelen awen pi laso lili",
  "block.minecraft.waxed_weathered_copper": "kiwen ante awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_bars": "sinpin palisa awen pi kiwen ante pi laso lili",
  "block.minecraft.waxed_weathered_copper_bulb": "kiwen ante suno awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_chain": "linja awen pi kiwen ante pi laso lili",
  "block.minecraft.waxed_weathered_copper_chest": "poki kiwen awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_door": "lupa ante awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_golem_statue": "jan ilo poki kiwen awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_grate": "kiwen ante lukin awen pi laso lili",
  "block.minecraft.waxed_weathered_copper_lantern": "poki suno awen pi kiwen ante pi laso lili",
  "block.minecraft.waxed_weathered_copper_trapdoor": "lupa anpa ante awen pi laso lili",
  "block.minecraft.waxed_weathered_cut_copper": "kiwen ante kipisi awen pi laso lili",
  "block.minecraft.waxed_weathered_cut_copper_slab": "supa pi kiwen ante awen pi laso lili",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "leko sewi awen pi kiwen ante pi laso lili",
  "block.minecraft.waxed_weathered_lightning_rod": "palisa awen pi linja wawa suno pi laso lili",
  "block.minecraft.weathered_chiseled_copper": "kiwen ante sitelen pi laso lili",
  "block.minecraft.weathered_copper": "kiwen ante pi laso lili",
  "block.minecraft.weathered_copper_bars": "sinpin palisa pi kiwen ante pi laso lili",
  "block.minecraft.weathered_copper_bulb": "suno ante pi laso lili",
  "block.minecraft.weathered_copper_chain": "linja pi kiwen ante pi laso lili",
  "block.minecraft.weathered_copper_chest": "poki kiwen pi laso lili",
  "block.minecraft.weathered_copper_door": "lupa ante pi laso lili",
  "block.minecraft.weathered_copper_golem_statue": "jan ilo poki kiwen pi laso lili",
  "block.minecraft.weathered_copper_grate": "kiwen ante lukin pi laso lili",
  "block.minecraft.weathered_copper_lantern": "poki suno pi kiwen ante pi laso lili",
  "block.minecraft.weathered_copper_trapdoor": "lupa anpa ante pi laso lili",
  "block.minecraft.weathered_cut_copper": "kiwen ante kipisi pi laso lili",
  "block.minecraft.weathered_cut_copper_slab": "supa pi kiwen ante pi laso lili",
  "block.minecraft.weathered_cut_copper_stairs": "leko sewi pi kiwen ante pi laso lili",
  "block.minecraft.weathered_lightning_rod": "palisa pi linja wawa suno pi laso lili",
  "block.minecraft.weeping_vines": "kasi linja loje",
  "block.minecraft.weeping_vines_plant": "kasi linja loje",
  "block.minecraft.wet_sponge": "ko telo",
  "block.minecraft.wheat": "kasi pan",
  "block.minecraft.white_banner": "len sitelen walo",
  "block.minecraft.white_bed": "supa lape walo",
  "block.minecraft.white_candle": "palisa suno lili walo",
  "block.minecraft.white_candle_cake": "palisa suno lili walo lon pan suwi",
  "block.minecraft.white_carpet": "len anpa walo",
  "block.minecraft.white_concrete": "kiwen kule walo",
  "block.minecraft.white_concrete_powder": "ko kule walo",
  "block.minecraft.white_glazed_terracotta": "kiwen namako walo",
  "block.minecraft.white_shulker_box": "poki walo pi monsuta Shulker",
  "block.minecraft.white_stained_glass": "kiwen lukin walo",
  "block.minecraft.white_stained_glass_pane": "sinpin lukin walo",
  "block.minecraft.white_terracotta": "ma kiwen walo",
  "block.minecraft.white_tulip": "kasi uta walo",
  "block.minecraft.white_wool": "len walo",
  "block.minecraft.wildflowers": "kasi kule lili",
  "block.minecraft.wither_rose": "kasi moli Wither",
  "block.minecraft.wither_skeleton_skull": "lawa pi jan moli palisa Wither",
  "block.minecraft.wither_skeleton_wall_skull": "lawa pi jan moli palisa Wither lon sinpin",
  "block.minecraft.yellow_banner": "len sitelen jelo",
  "block.minecraft.yellow_bed": "supa lape jelo",
  "block.minecraft.yellow_candle": "palisa suno lili jelo",
  "block.minecraft.yellow_candle_cake": "palisa suno lili jelo lon pan suwi",
  "block.minecraft.yellow_carpet": "len anpa jelo",
  "block.minecraft.yellow_concrete": "kiwen kule jelo",
  "block.minecraft.yellow_concrete_powder": "ko kule jelo",
  "block.minecraft.yellow_glazed_terracotta": "kiwen namako jelo",
  "block.minecraft.yellow_shulker_box": "poki jelo pi monsuta Shulker",
  "block.minecraft.yellow_stained_glass": "kiwen lukin jelo",
  "block.minecraft.yellow_stained_glass_pane": "sinpin lukin jelo",
  "block.minecraft.yellow_terracotta": "ma kiwen jelo",
  "block.minecraft.yellow_wool": "len jelo",
  "block.minecraft.zombie_head": "lawa pi jan moli",
  "block.minecraft.zombie_wall_head": "lawa pi jan moli lon sinpin",
  "item.minecraft.acacia_boat": "ilo tawa telo pi kasi seli",
  "item.minecraft.acacia_chest_boat": "poki lon ilo tawa telo pi kasi seli",
  "item.minecraft.allay_spawn_egg": "sike mama pi kon pona",
  "item.minecraft.amethyst_shard": "kipisi pi kiwen kalama",
  "item.minecraft.angler_pottery_shard": "kipisi poki kala",
  "item.minecraft.angler_pottery_sherd": "kipisi poki kala",
  "item.minecraft.apple": "kili loje",
  "item.minecraft.archer_pottery_shard": "kipisi poki alasa",
  "item.minecraft.archer_pottery_sherd": "kipisi poki alasa",
  "item.minecraft.armadillo_scute": "kiwen selo tan soweli pi kiwen selo",
  "item.minecraft.armadillo_spawn_egg": "sike mama pi soweli pi kiwen selo",
  "item.minecraft.armor_stand": "ilo jo len",
  "item.minecraft.arms_up_pottery_shard": "kipisi poki wawa",
  "item.minecraft.arms_up_pottery_sherd": "kipisi poki wawa",
  "item.minecraft.arrow": "palisa alasa",
  "item.minecraft.axolotl_bucket": "akesi suwi lon poki",
  "item.minecraft.axolotl_spawn_egg": "sike mama pi akesi suwi",
  "item.minecraft.baked_potato": "kili ma seli",
  "item.minecraft.bamboo_chest_raft": "poki lon supa tawa telo pi kasi palisa",
  "item.minecraft.bamboo_raft": "supa tawa telo pi kasi palisa",
  "item.minecraft.bat_spawn_egg": "sike mama pi waso pimeja",
  "item.minecraft.bee_spawn_egg": "sike mama pi pipi suwi",
  "item.minecraft.beef": "moku mani lete",
  "item.minecraft.beetroot": "kili ma loje",
  "item.minecraft.beetroot_seeds": "sike mama pi kili ma loje",
  "item.minecraft.beetroot_soup": "telo moku pi kili ma loje",
  "item.minecraft.birch_boat": "ilo tawa telo pi kasi jelo",
  "item.minecraft.birch_chest_boat": "poki lon ilo tawa telo pi kasi jelo",
  "item.minecraft.black_bundle": "poki len pimeja",
  "item.minecraft.black_dye": "kule pimeja",
  "item.minecraft.black_harness": "len sewi waso pimeja",
  "item.minecraft.blade_pottery_shard": "kipisi poki utala",
  "item.minecraft.blade_pottery_sherd": "kipisi poki utala",
  "item.minecraft.blaze_powder": "ko pi palisa seli",
  "item.minecraft.blaze_rod": "palisa seli",
  "item.minecraft.blaze_spawn_egg": "sike mama pi monsuta seli",
  "item.minecraft.blue_bundle": "poki len pi laso telo",
  "item.minecraft.blue_dye": "kule pi laso telo",
  "item.minecraft.blue_egg": "sike mama waso laso",
  "item.minecraft.blue_harness": "len sewi waso pi laso telo",
  "item.minecraft.bogged_spawn_egg": "sike mama pi jan moli jaki",
  "item.minecraft.bolt_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "namako len tawa",
  "item.minecraft.bone": "palisa sijelo",
  "item.minecraft.bone_meal": "ko pi palisa sijelo",
  "item.minecraft.book": "lipu suli",
  "item.minecraft.bordure_indented_banner_pattern": "ilo sitelen pi selo nena",
  "item.minecraft.bow": "ilo alasa",
  "item.minecraft.bowl": "poki moku",
  "item.minecraft.bread": "pan",
  "item.minecraft.breeze_rod": "palisa kon",
  "item.minecraft.breeze_spawn_egg": "sike mama pi monsuta kon",
  "item.minecraft.brewer_pottery_shard": "kipisi poki telo",
  "item.minecraft.brewer_pottery_sherd": "kipisi poki telo",
  "item.minecraft.brewing_stand": "ilo pi telo wawa",
  "item.minecraft.brick": "leko lili",
  "item.minecraft.brown_bundle": "poki len pi loje ma",
  "item.minecraft.brown_dye": "kule pi loje ma",
  "item.minecraft.brown_egg": "sike mama waso loje",
  "item.minecraft.brown_harness": "len sewi waso pi loje ma",
  "item.minecraft.brush": "ilo pi weka ko",
  "item.minecraft.bucket": "poki telo",
  "item.minecraft.bundle": "poki len",
  "item.minecraft.bundle.empty": "jo ala",
  "item.minecraft.bundle.empty.description": "ni li ken jo e kulupu pi ijo mute ante",
  "item.minecraft.bundle.full": "jo ale",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "kipisi poki seli",
  "item.minecraft.burn_pottery_sherd": "kipisi poki seli",
  "item.minecraft.camel_husk_spawn_egg": "sike mama pi soweli moli seli pi nena monsi",
  "item.minecraft.camel_spawn_egg": "sike mama pi soweli pi nena monsi",
  "item.minecraft.carrot": "kili palisa",
  "item.minecraft.carrot_on_a_stick": "kili palisa lon palisa",
  "item.minecraft.cat_spawn_egg": "sike mama pi soweli suwi",
  "item.minecraft.cauldron": "poki telo suli",
  "item.minecraft.cave_spider_spawn_egg": "sike mama pi pipi lupa",
  "item.minecraft.chainmail_boots": "len noka anpa pi sike lili",
  "item.minecraft.chainmail_chestplate": "len sijelo pi sike lili",
  "item.minecraft.chainmail_helmet": "len lawa pi sike lili",
  "item.minecraft.chainmail_leggings": "len noka pi sike lili",
  "item.minecraft.charcoal": "kiwen kasi pi moku seli",
  "item.minecraft.cherry_boat": "ilo tawa telo pi kasi suwi",
  "item.minecraft.cherry_chest_boat": "poki lon ilo tawa telo pi kasi suwi",
  "item.minecraft.chest_minecart": "poki ijo lon poki tawa",
  "item.minecraft.chicken": "moku waso lete",
  "item.minecraft.chicken_spawn_egg": "sike mama pi waso moku",
  "item.minecraft.chorus_fruit": "kili nasa",
  "item.minecraft.clay_ball": "sike pi ma ko",
  "item.minecraft.clock": "ilo tenpo",
  "item.minecraft.coal": "ko pimeja",
  "item.minecraft.coast_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.coast_armor_trim_smithing_template.new": "namako len telo",
  "item.minecraft.cocoa_beans": "kili pi kule ma",
  "item.minecraft.cod": "kala walo lete",
  "item.minecraft.cod_bucket": "kala walo lon poki",
  "item.minecraft.cod_spawn_egg": "sike mama pi kala walo",
  "item.minecraft.command_block_minecart": "ilo pi toki wawa lon poki tawa",
  "item.minecraft.compass": "ilo nasin",
  "item.minecraft.cooked_beef": "moku mani seli",
  "item.minecraft.cooked_chicken": "moku waso seli",
  "item.minecraft.cooked_cod": "moku seli pi kala walo",
  "item.minecraft.cooked_mutton": "moku seli pi soweli len",
  "item.minecraft.cooked_porkchop": "moku seli pi soweli moku",
  "item.minecraft.cooked_rabbit": "moku seli pi soweli lili",
  "item.minecraft.cooked_salmon": "moku seli pi kala loje",
  "item.minecraft.cookie": "pan sike suwi",
  "item.minecraft.copper_axe": "ilo kipisi ante",
  "item.minecraft.copper_boots": "len noka anpa ante",
  "item.minecraft.copper_chestplate": "len sijelo ante",
  "item.minecraft.copper_golem_spawn_egg": "sike mama pi jan ilo poki",
  "item.minecraft.copper_helmet": "len lawa ante",
  "item.minecraft.copper_hoe": "ilo kasi ante",
  "item.minecraft.copper_horse_armor": "len soweli ante",
  "item.minecraft.copper_ingot": "kiwen ante",
  "item.minecraft.copper_leggings": "len noka ante",
  "item.minecraft.copper_nautilus_armor": "len kala ante",
  "item.minecraft.copper_nugget": "kiwen ante lili",
  "item.minecraft.copper_pickaxe": "ilo pakala ante",
  "item.minecraft.copper_shovel": "ilo ma ante",
  "item.minecraft.copper_spear": "palisa utala tawa ante",
  "item.minecraft.copper_sword": "palisa utala ante",
  "item.minecraft.cow_spawn_egg": "sike mama mani",
  "item.minecraft.creaking_spawn_egg": "sike mama pi monsuta kasi",
  "item.minecraft.creeper_banner_pattern": "ilo sitelen",
  "item.minecraft.creeper_banner_pattern.desc": "sinpin pi monsuta Creeper",
  "item.minecraft.creeper_banner_pattern.new": "ilo sitelen pi monsuta Creeper",
  "item.minecraft.creeper_spawn_egg": "sike mama pi monsuta Creeper",
  "item.minecraft.crossbow": "ilo alasa supa",
  "item.minecraft.crossbow.projectile": "ijo pana:",
  "item.minecraft.crossbow.projectile.multiple": "ijo pana: %s x %s",
  "item.minecraft.crossbow.projectile.single": "ijo pana: %s",
  "item.minecraft.cyan_bundle": "poki len laso",
  "item.minecraft.cyan_dye": "kule laso",
  "item.minecraft.cyan_harness": "len sewi waso laso",
  "item.minecraft.danger_pottery_shard": "kipisi poki monsuta",
  "item.minecraft.danger_pottery_sherd": "kipisi poki monsuta",
  "item.minecraft.dark_oak_boat": "ilo tawa telo pi kasi pimeja",
  "item.minecraft.dark_oak_chest_boat": "poki lon ilo tawa telo pi kasi pimeja",
  "item.minecraft.debug_stick": "palisa wawa",
  "item.minecraft.debug_stick.empty": "%s li jo e ijo ala",
  "item.minecraft.debug_stick.select": "nasin \"%s\" la \"%s\" li lon",
  "item.minecraft.debug_stick.update": "\"%s\" li kama %s",
  "item.minecraft.diamond": "kiwen laso",
  "item.minecraft.diamond_axe": "ilo kipisi laso",
  "item.minecraft.diamond_boots": "len noka anpa laso",
  "item.minecraft.diamond_chestplate": "len sijelo laso",
  "item.minecraft.diamond_helmet": "len lawa laso",
  "item.minecraft.diamond_hoe": "ilo kasi laso",
  "item.minecraft.diamond_horse_armor": "len soweli laso",
  "item.minecraft.diamond_leggings": "len noka laso",
  "item.minecraft.diamond_nautilus_armor": "len kala laso",
  "item.minecraft.diamond_pickaxe": "ilo pakala laso",
  "item.minecraft.diamond_shovel": "ilo ma laso",
  "item.minecraft.diamond_spear": "palisa utala tawa laso",
  "item.minecraft.diamond_sword": "palisa utala laso",
  "item.minecraft.disc_fragment_5": "kipisi pi sike kalama",
  "item.minecraft.disc_fragment_5.desc": "sike kalama - 5",
  "item.minecraft.dolphin_spawn_egg": "sike mama pi kala suli",
  "item.minecraft.donkey_spawn_egg": "sike mama pi soweli jo",
  "item.minecraft.dragon_breath": "kon akesi",
  "item.minecraft.dried_kelp": "kasi telo seli",
  "item.minecraft.drowned_spawn_egg": "sike mama pi jan moli telo",
  "item.minecraft.dune_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.dune_armor_trim_smithing_template.new": "namako len seli",
  "item.minecraft.echo_shard": "kipisi pi kalama sama",
  "item.minecraft.egg": "sike mama waso walo",
  "item.minecraft.elder_guardian_spawn_egg": "sike mama pi kala oko suli",
  "item.minecraft.elytra": "luka waso",
  "item.minecraft.emerald": "kiwen esun",
  "item.minecraft.enchanted_book": "lipu wawa",
  "item.minecraft.enchanted_golden_apple": "kili mani wawa",
  "item.minecraft.end_crystal": "ilo wawa pi ma End",
  "item.minecraft.ender_dragon_spawn_egg": "sike mama pi akesi pi ma End",
  "item.minecraft.ender_eye": "oko pi ma End",
  "item.minecraft.ender_pearl": "sike pi ma End",
  "item.minecraft.enderman_spawn_egg": "sike mama pi jan pi ma End",
  "item.minecraft.endermite_spawn_egg": "sike mama pi pipi pi ma End",
  "item.minecraft.evoker_spawn_egg": "sike mama pi jan ike wawa",
  "item.minecraft.experience_bottle": "wawa laso lon poki",
  "item.minecraft.explorer_pottery_shard": "kipisi poki lipu",
  "item.minecraft.explorer_pottery_sherd": "kipisi poki lipu",
  "item.minecraft.eye_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.eye_armor_trim_smithing_template.new": "namako len oko",
  "item.minecraft.feather": "lipu waso",
  "item.minecraft.fermented_spider_eye": "oko pipi nasa",
  "item.minecraft.field_masoned_banner_pattern": "ilo sitelen pi leko lili",
  "item.minecraft.filled_map": "sitelen ma",
  "item.minecraft.fire_charge": "sike seli",
  "item.minecraft.firework_rocket": "palisa pi seli kule",
  "item.minecraft.firework_rocket.flight": "wawa tawa:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "sike pi seli kule",
  "item.minecraft.firework_star.black": "pimeja",
  "item.minecraft.firework_star.blue": "laso telo",
  "item.minecraft.firework_star.brown": "loje ma",
  "item.minecraft.firework_star.custom_color": "kule ante",
  "item.minecraft.firework_star.cyan": "laso",
  "item.minecraft.firework_star.fade_to": "kama",
  "item.minecraft.firework_star.flicker": "tawa mun",
  "item.minecraft.firework_star.gray": "pimeja walo",
  "item.minecraft.firework_star.green": "laso kasi",
  "item.minecraft.firework_star.light_blue": "laso sewi",
  "item.minecraft.firework_star.light_gray": "walo pimeja",
  "item.minecraft.firework_star.lime": "laso jelo",
  "item.minecraft.firework_star.magenta": "loje laso",
  "item.minecraft.firework_star.orange": "loje jelo",
  "item.minecraft.firework_star.pink": "loje walo",
  "item.minecraft.firework_star.purple": "laso loje",
  "item.minecraft.firework_star.red": "loje",
  "item.minecraft.firework_star.shape": "selo ante",
  "item.minecraft.firework_star.shape.burst": "pakala wawa",
  "item.minecraft.firework_star.shape.creeper": "sinpin pi monsuta Creeper",
  "item.minecraft.firework_star.shape.large_ball": "sike suli",
  "item.minecraft.firework_star.shape.small_ball": "sike lili",
  "item.minecraft.firework_star.shape.star": "selo mun",
  "item.minecraft.firework_star.trail": "linja suno",
  "item.minecraft.firework_star.white": "walo",
  "item.minecraft.firework_star.yellow": "jelo",
  "item.minecraft.fishing_rod": "ilo kala",
  "item.minecraft.flint": "kiwen pimeja kipisi",
  "item.minecraft.flint_and_steel": "ilo seli",
  "item.minecraft.flow_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.flow_armor_trim_smithing_template.new": "namako len esun",
  "item.minecraft.flow_banner_pattern": "ilo sitelen",
  "item.minecraft.flow_banner_pattern.desc": "esun",
  "item.minecraft.flow_banner_pattern.new": "ilo sitelen esun",
  "item.minecraft.flow_pottery_sherd": "kipisi poki esun",
  "item.minecraft.flower_banner_pattern": "ilo sitelen pi kasi kule",
  "item.minecraft.flower_banner_pattern.desc": "kasi kule",
  "item.minecraft.flower_banner_pattern.new": "ilo sitelen pi kasi kule",
  "item.minecraft.flower_pot": "poki kasi",
  "item.minecraft.fox_spawn_egg": "sike mama pi soweli pi linja monsi",
  "item.minecraft.friend_pottery_shard": "kipisi poki pona",
  "item.minecraft.friend_pottery_sherd": "kipisi poki pona",
  "item.minecraft.frog_spawn_egg": "sike mama pi akesi sewi",
  "item.minecraft.furnace_minecart": "poki seli lon poki tawa",
  "item.minecraft.ghast_spawn_egg": "sike mama pi monsuta Ghast",
  "item.minecraft.ghast_tear": "telo oko pi monsuta Ghast",
  "item.minecraft.glass_bottle": "poki lili",
  "item.minecraft.glistering_melon_slice": "kipisi kili mani",
  "item.minecraft.globe_banner_pattern": "ilo sitelen pi leko ma",
  "item.minecraft.globe_banner_pattern.desc": "sike pi ma ale",
  "item.minecraft.globe_banner_pattern.new": "ilo sitelen pi leko ma",
  "item.minecraft.glow_berries": "kili lili suno",
  "item.minecraft.glow_ink_sac": "telo suno",
  "item.minecraft.glow_item_frame": "lipu poki suno",
  "item.minecraft.glow_squid_spawn_egg": "sike mama pi kala luka suno",
  "item.minecraft.glowstone_dust": "ko suno",
  "item.minecraft.goat_horn": "palisa kalama pi soweli nena",
  "item.minecraft.goat_spawn_egg": "sike mama pi soweli nena",
  "item.minecraft.gold_ingot": "kiwen jelo",
  "item.minecraft.gold_nugget": "kiwen jelo lili",
  "item.minecraft.golden_apple": "kili mani",
  "item.minecraft.golden_axe": "ilo kipisi jelo",
  "item.minecraft.golden_boots": "len noka anpa jelo",
  "item.minecraft.golden_carrot": "kili palisa mani",
  "item.minecraft.golden_chestplate": "len sijelo jelo",
  "item.minecraft.golden_helmet": "len lawa jelo",
  "item.minecraft.golden_hoe": "ilo kasi jelo",
  "item.minecraft.golden_horse_armor": "len soweli jelo",
  "item.minecraft.golden_leggings": "len noka jelo",
  "item.minecraft.golden_nautilus_armor": "len kala jelo",
  "item.minecraft.golden_pickaxe": "ilo pakala jelo",
  "item.minecraft.golden_shovel": "ilo ma jelo",
  "item.minecraft.golden_spear": "palisa utala tawa jelo",
  "item.minecraft.golden_sword": "palisa utala jelo",
  "item.minecraft.gray_bundle": "poki len pi pimeja walo",
  "item.minecraft.gray_dye": "kule pi pimeja walo",
  "item.minecraft.gray_harness": "len sewi waso pi pimeja walo",
  "item.minecraft.green_bundle": "poki len pi laso kasi",
  "item.minecraft.green_dye": "kule kasi",
  "item.minecraft.green_harness": "len sewi waso pi laso kasi",
  "item.minecraft.guardian_spawn_egg": "sike mama pi kala oko",
  "item.minecraft.gunpowder": "ko pi seli pakala",
  "item.minecraft.guster_banner_pattern": "ilo sitelen",
  "item.minecraft.guster_banner_pattern.desc": "monsuta kon",
  "item.minecraft.guster_banner_pattern.new": "ilo sitelen pi monsuta kon",
  "item.minecraft.guster_pottery_sherd": "kipisi poki pi monsuta kon",
  "item.minecraft.happy_ghast_spawn_egg": "sike mama pi waso pona Ghast",
  "item.minecraft.harness": "len sewi pi waso pona",
  "item.minecraft.heart_of_the_sea": "pilin pi telo suli",
  "item.minecraft.heart_pottery_shard": "kipisi poki pilin",
  "item.minecraft.heart_pottery_sherd": "kipisi poki pilin",
  "item.minecraft.heartbreak_pottery_shard": "kipisi poki pakala",
  "item.minecraft.heartbreak_pottery_sherd": "kipisi poki pakala",
  "item.minecraft.hoglin_spawn_egg": "sike mama pi soweli Hoglin",
  "item.minecraft.honey_bottle": "suwi pipi lon poki",
  "item.minecraft.honeycomb": "lipu suwi",
  "item.minecraft.hopper_minecart": "poki pi tawa ijo lon poki tawa",
  "item.minecraft.horse_spawn_egg": "sike mama pi soweli tawa",
  "item.minecraft.host_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.host_armor_trim_smithing_template.new": "namako len lawa",
  "item.minecraft.howl_pottery_shard": "kipisi poki soweli",
  "item.minecraft.howl_pottery_sherd": "kipisi poki soweli",
  "item.minecraft.husk_spawn_egg": "sike mama pi jan moli seli",
  "item.minecraft.ink_sac": "telo pimeja",
  "item.minecraft.iron_axe": "ilo kipisi walo",
  "item.minecraft.iron_boots": "len noka anpa walo",
  "item.minecraft.iron_chestplate": "len sijelo walo",
  "item.minecraft.iron_golem_spawn_egg": "sike mama pi jan ilo pi kiwen walo",
  "item.minecraft.iron_helmet": "len lawa walo",
  "item.minecraft.iron_hoe": "ilo kasi walo",
  "item.minecraft.iron_horse_armor": "len soweli walo",
  "item.minecraft.iron_ingot": "kiwen walo",
  "item.minecraft.iron_leggings": "len noka walo",
  "item.minecraft.iron_nautilus_armor": "len kala walo",
  "item.minecraft.iron_nugget": "kiwen walo lili",
  "item.minecraft.iron_pickaxe": "ilo pakala walo",
  "item.minecraft.iron_shovel": "ilo ma walo",
  "item.minecraft.iron_spear": "palisa utala tawa walo",
  "item.minecraft.iron_sword": "palisa utala walo",
  "item.minecraft.item_frame": "lipu poki",
  "item.minecraft.jungle_boat": "ilo tawa telo pi kasi suli",
  "item.minecraft.jungle_chest_boat": "poki lon ilo tawa telo pi kasi suli",
  "item.minecraft.knowledge_book": "lipu pi sona pali",
  "item.minecraft.lapis_lazuli": "kiwen pi laso telo",
  "item.minecraft.lava_bucket": "telo seli lon poki",
  "item.minecraft.lead": "linja lawa",
  "item.minecraft.leather": "selo soweli",
  "item.minecraft.leather_boots": "len noka anpa selo",
  "item.minecraft.leather_chestplate": "len sijelo selo",
  "item.minecraft.leather_helmet": "len lawa selo",
  "item.minecraft.leather_horse_armor": "len soweli selo",
  "item.minecraft.leather_leggings": "len noka selo",
  "item.minecraft.light_blue_bundle": "poki len pi laso sewi",
  "item.minecraft.light_blue_dye": "kule pi laso sewi",
  "item.minecraft.light_blue_harness": "len sewi waso pi laso sewi",
  "item.minecraft.light_gray_bundle": "poki len pi walo pimeja",
  "item.minecraft.light_gray_dye": "kule pi walo pimeja",
  "item.minecraft.light_gray_harness": "len sewi waso pi walo pimeja",
  "item.minecraft.lime_bundle": "poki len pi laso jelo",
  "item.minecraft.lime_dye": "kule pi laso jelo",
  "item.minecraft.lime_harness": "len sewi waso pi laso jelo",
  "item.minecraft.lingering_potion": "kon wawa",
  "item.minecraft.lingering_potion.effect.awkward": "kon wawa pi soko wawa",
  "item.minecraft.lingering_potion.effect.empty": "kon wawa pi ken ala pali",
  "item.minecraft.lingering_potion.effect.fire_resistance": "kon wawa pi awen lete",
  "item.minecraft.lingering_potion.effect.harming": "kon wawa pi ike sijelo",
  "item.minecraft.lingering_potion.effect.healing": "kon wawa pi pona sijelo",
  "item.minecraft.lingering_potion.effect.infested": "kon wawa pi kama pipi",
  "item.minecraft.lingering_potion.effect.invisibility": "kon wawa pi sijelo kon",
  "item.minecraft.lingering_potion.effect.leaping": "kon wawa pi noka wawa",
  "item.minecraft.lingering_potion.effect.levitation": "kon wawa pi tawa sewi",
  "item.minecraft.lingering_potion.effect.luck": "kon wawa pi ken pona",
  "item.minecraft.lingering_potion.effect.mundane": "kon wawa pi wawa lili",
  "item.minecraft.lingering_potion.effect.night_vision": "kon wawa pi lukin wawa",
  "item.minecraft.lingering_potion.effect.oozing": "kon wawa pi pana ko",
  "item.minecraft.lingering_potion.effect.poison": "kon wawa pi ike sijelo kama",
  "item.minecraft.lingering_potion.effect.regeneration": "kon wawa pi pona sijelo kama",
  "item.minecraft.lingering_potion.effect.slow_falling": "kon wawa pi anpa ala",
  "item.minecraft.lingering_potion.effect.slowness": "kon wawa pi tawa ike",
  "item.minecraft.lingering_potion.effect.strength": "kon wawa pi utala wawa",
  "item.minecraft.lingering_potion.effect.swiftness": "kon wawa pi tawa wawa",
  "item.minecraft.lingering_potion.effect.thick": "kon wawa pi wawa lili",
  "item.minecraft.lingering_potion.effect.turtle_master": "kon wawa pi kama kiwen",
  "item.minecraft.lingering_potion.effect.water": "telo kon",
  "item.minecraft.lingering_potion.effect.water_breathing": "kon wawa pi kon telo",
  "item.minecraft.lingering_potion.effect.weakness": "kon wawa pi utala ike",
  "item.minecraft.lingering_potion.effect.weaving": "kon wawa pi kama linja",
  "item.minecraft.lingering_potion.effect.wind_charged": "kon wawa pi pana kon",
  "item.minecraft.llama_spawn_egg": "sike mama pi soweli pi telo uta",
  "item.minecraft.lodestone_compass": "ilo nasin pi kiwen nasin",
  "item.minecraft.mace": "palisa wawa",
  "item.minecraft.magenta_bundle": "poki len pi loje laso",
  "item.minecraft.magenta_dye": "kule pi loje laso",
  "item.minecraft.magenta_harness": "len sewi waso pi loje laso",
  "item.minecraft.magma_cream": "ko monsuta seli",
  "item.minecraft.magma_cube_spawn_egg": "sike mama pi monsuta ko seli",
  "item.minecraft.mangrove_boat": "ilo tawa telo pi kasi telo",
  "item.minecraft.mangrove_chest_boat": "poki lon ilo tawa telo pi kasi telo",
  "item.minecraft.map": "sitelen ma weka",
  "item.minecraft.melon_seeds": "sike mama pi kili suli laso",
  "item.minecraft.melon_slice": "kipisi pi kili suli laso",
  "item.minecraft.milk_bucket": "telo walo lon poki",
  "item.minecraft.minecart": "poki tawa",
  "item.minecraft.miner_pottery_shard": "kipisi poki ilo",
  "item.minecraft.miner_pottery_sherd": "kipisi poki ilo",
  "item.minecraft.mojang_banner_pattern": "ilo sitelen ijo",
  "item.minecraft.mojang_banner_pattern.desc": "ijo",
  "item.minecraft.mojang_banner_pattern.new": "ilo sitelen ijo",
  "item.minecraft.mooshroom_spawn_egg": "sike mama pi mani Mooshroom",
  "item.minecraft.mourner_pottery_shard": "kipisi poki kute",
  "item.minecraft.mourner_pottery_sherd": "kipisi poki kute",
  "item.minecraft.mule_spawn_egg": "sike mama pi soweli jo tawa",
  "item.minecraft.mushroom_stew": "telo moku soko",
  "item.minecraft.music_disc_11": "sike kalama",
  "item.minecraft.music_disc_11.desc": "jan C418 - 11",
  "item.minecraft.music_disc_13": "sike kalama",
  "item.minecraft.music_disc_13.desc": "jan C418 - 13",
  "item.minecraft.music_disc_5": "sike kalama",
  "item.minecraft.music_disc_5.desc": "jan Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "sike kalama",
  "item.minecraft.music_disc_blocks.desc": "jan C418 - blocks",
  "item.minecraft.music_disc_cat": "sike kalama",
  "item.minecraft.music_disc_cat.desc": "jan C418 - cat",
  "item.minecraft.music_disc_chirp": "sike kalama",
  "item.minecraft.music_disc_chirp.desc": "jan C418 - chirp",
  "item.minecraft.music_disc_creator": "sike kalama",
  "item.minecraft.music_disc_creator.desc": "jan Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "sike kalama",
  "item.minecraft.music_disc_creator_music_box.desc": "jan Lena Raine - Creator (kepeken poki pi kalama musi)",
  "item.minecraft.music_disc_far": "sike kalama",
  "item.minecraft.music_disc_far.desc": "jan C418 - far",
  "item.minecraft.music_disc_lava_chicken": "sike kalama",
  "item.minecraft.music_disc_lava_chicken.desc": "kulupu Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "sike kalama",
  "item.minecraft.music_disc_mall.desc": "jan C418 - mall",
  "item.minecraft.music_disc_mellohi": "sike kalama",
  "item.minecraft.music_disc_mellohi.desc": "jan C418 - mellohi",
  "item.minecraft.music_disc_otherside": "sike kalama",
  "item.minecraft.music_disc_otherside.desc": "jan Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "sike kalama",
  "item.minecraft.music_disc_pigstep.desc": "jan Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "sike kalama",
  "item.minecraft.music_disc_precipice.desc": "jan Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "sike kalama",
  "item.minecraft.music_disc_relic.desc": "jan Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "sike kalama",
  "item.minecraft.music_disc_stal.desc": "jan C418 - stal",
  "item.minecraft.music_disc_strad": "sike kalama",
  "item.minecraft.music_disc_strad.desc": "jan C418 - strad",
  "item.minecraft.music_disc_tears": "sike kalama",
  "item.minecraft.music_disc_tears.desc": "jan Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "sike kalama",
  "item.minecraft.music_disc_wait.desc": "jan C418 - wait",
  "item.minecraft.music_disc_ward": "sike kalama",
  "item.minecraft.music_disc_ward.desc": "jan C418 - ward",
  "item.minecraft.mutton": "moku lete pi soweli len",
  "item.minecraft.name_tag": "lipu nimi",
  "item.minecraft.nautilus_shell": "tomo pi kala sike",
  "item.minecraft.nautilus_spawn_egg": "sike mama pi kala sike",
  "item.minecraft.nether_brick": "kiwen leko lili pi ma Nether",
  "item.minecraft.nether_star": "mun pi ma Nether",
  "item.minecraft.nether_wart": "soko wawa pi ma Nether",
  "item.minecraft.netherite_axe": "ilo kipisi pi mani Netherite",
  "item.minecraft.netherite_boots": "len noka anpa pi mani Netherite",
  "item.minecraft.netherite_chestplate": "len sijelo pi mani Netherite",
  "item.minecraft.netherite_helmet": "len lawa pi mani Netherite",
  "item.minecraft.netherite_hoe": "ilo kasi pi mani Netherite",
  "item.minecraft.netherite_horse_armor": "len soweli pi mani Netherite",
  "item.minecraft.netherite_ingot": "mani Netherite",
  "item.minecraft.netherite_leggings": "len noka pi mani Netherite",
  "item.minecraft.netherite_nautilus_armor": "len kala pi mani Netherite",
  "item.minecraft.netherite_pickaxe": "ilo pakala pi mani Netherite",
  "item.minecraft.netherite_scrap": "mani Netherite pakala",
  "item.minecraft.netherite_shovel": "ilo ma pi mani Netherite",
  "item.minecraft.netherite_spear": "palisa utala tawa pi mani Netherite",
  "item.minecraft.netherite_sword": "palisa utala pi mani Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "lipu pi namako len",
  "item.minecraft.netherite_upgrade_smithing_template.new": "namako len wawa pi mani Netherite",
  "item.minecraft.oak_boat": "ilo tawa telo pi kasi kili",
  "item.minecraft.oak_chest_boat": "poki lon ilo tawa telo pi kasi kili",
  "item.minecraft.ocelot_spawn_egg": "sike mama pi soweli alasa",
  "item.minecraft.ominous_bottle": "poki lili ike",
  "item.minecraft.ominous_trial_key": "ilo open ike pi tomo alasa",
  "item.minecraft.orange_bundle": "poki len pi loje jelo",
  "item.minecraft.orange_dye": "kule pi loje jelo",
  "item.minecraft.orange_harness": "len sewi waso pi loje jelo",
  "item.minecraft.painting": "sitelen",
  "item.minecraft.pale_oak_boat": "ilo tawa telo pi kasi walo",
  "item.minecraft.pale_oak_chest_boat": "poki lon ilo tawa telo pi kasi walo",
  "item.minecraft.panda_spawn_egg": "sike mama pi soweli pimeja walo",
  "item.minecraft.paper": "lipu",
  "item.minecraft.parched_spawn_egg": "sike mama pi jan palisa seli",
  "item.minecraft.parrot_spawn_egg": "sike mama pi waso toki",
  "item.minecraft.phantom_membrane": "selo pi waso mun",
  "item.minecraft.phantom_spawn_egg": "sike mama pi waso mun",
  "item.minecraft.pig_spawn_egg": "sike mama pi soweli moku",
  "item.minecraft.piglin_banner_pattern": "ilo sitelen pi nena soweli",
  "item.minecraft.piglin_banner_pattern.desc": "nena soweli",
  "item.minecraft.piglin_banner_pattern.new": "ilo sitelen pi nena soweli",
  "item.minecraft.piglin_brute_spawn_egg": "sike mama pi jan Piglin wawa",
  "item.minecraft.piglin_spawn_egg": "sike mama pi jan Piglin",
  "item.minecraft.pillager_spawn_egg": "sike mama pi jan ike alasa",
  "item.minecraft.pink_bundle": "poki len pi loje walo",
  "item.minecraft.pink_dye": "kule pi loje walo",
  "item.minecraft.pink_harness": "len sewi waso pi loje walo",
  "item.minecraft.pitcher_plant": "kasi poki",
  "item.minecraft.pitcher_pod": "sike mama pi kasi poki",
  "item.minecraft.plenty_pottery_shard": "kipisi poki poki",
  "item.minecraft.plenty_pottery_sherd": "kipisi poki poki",
  "item.minecraft.poisonous_potato": "kili ma jaki",
  "item.minecraft.polar_bear_spawn_egg": "sike mama pi soweli lete",
  "item.minecraft.popped_chorus_fruit": "kili nasa seli",
  "item.minecraft.porkchop": "moku lete pi soweli moku",
  "item.minecraft.potato": "kili ma",
  "item.minecraft.potion": "telo wawa",
  "item.minecraft.potion.effect.awkward": "telo pi soko wawa",
  "item.minecraft.potion.effect.empty": "telo pi ken ala pali",
  "item.minecraft.potion.effect.fire_resistance": "telo pi awen lete",
  "item.minecraft.potion.effect.harming": "telo pi ike sijelo",
  "item.minecraft.potion.effect.healing": "telo pi pona sijelo",
  "item.minecraft.potion.effect.infested": "telo pi kama pipi",
  "item.minecraft.potion.effect.invisibility": "telo pi sijelo kon",
  "item.minecraft.potion.effect.leaping": "telo pi noka wawa",
  "item.minecraft.potion.effect.levitation": "telo pi tawa sewi",
  "item.minecraft.potion.effect.luck": "telo pi ken pona",
  "item.minecraft.potion.effect.mundane": "telo pi wawa lili",
  "item.minecraft.potion.effect.night_vision": "telo pi lukin wawa",
  "item.minecraft.potion.effect.oozing": "telo pi pana ko",
  "item.minecraft.potion.effect.poison": "telo pi ike sijelo kama",
  "item.minecraft.potion.effect.regeneration": "telo pi pona sijelo kama",
  "item.minecraft.potion.effect.slow_falling": "telo pi anpa ala",
  "item.minecraft.potion.effect.slowness": "telo pi tawa ike",
  "item.minecraft.potion.effect.strength": "telo pi utala wawa",
  "item.minecraft.potion.effect.swiftness": "telo pi tawa wawa",
  "item.minecraft.potion.effect.thick": "telo pi ko suno",
  "item.minecraft.potion.effect.turtle_master": "telo pi kama kiwen",
  "item.minecraft.potion.effect.water": "telo lon poki lili",
  "item.minecraft.potion.effect.water_breathing": "telo pi kon telo",
  "item.minecraft.potion.effect.weakness": "telo pi utala ike",
  "item.minecraft.potion.effect.weaving": "telo pi kama linja",
  "item.minecraft.potion.effect.wind_charged": "telo pi pana kon",
  "item.minecraft.pottery_shard_archer": "kipisi poki alasa",
  "item.minecraft.pottery_shard_arms_up": "kipisi poki wawa",
  "item.minecraft.pottery_shard_prize": "kipisi poki kiwen",
  "item.minecraft.pottery_shard_skull": "kipisi poki lawa",
  "item.minecraft.powder_snow_bucket": "ko lete kon lon poki",
  "item.minecraft.prismarine_crystals": "kipisi suno pi kiwen Prismarine",
  "item.minecraft.prismarine_shard": "kipisi pi kiwen Prismarine",
  "item.minecraft.prize_pottery_shard": "kipisi poki kiwen",
  "item.minecraft.prize_pottery_sherd": "kipisi poki kiwen",
  "item.minecraft.pufferfish": "kala pi kama suli",
  "item.minecraft.pufferfish_bucket": "kala pi kama suli lon poki",
  "item.minecraft.pufferfish_spawn_egg": "sike mama pi kala pi kama suli",
  "item.minecraft.pumpkin_pie": "pan suwi pi kili suli jelo",
  "item.minecraft.pumpkin_seeds": "sike mama pi kili suli jelo",
  "item.minecraft.purple_bundle": "poki len pi laso loje",
  "item.minecraft.purple_dye": "kule pi laso loje",
  "item.minecraft.purple_harness": "len sewi waso pi laso loje",
  "item.minecraft.quartz": "kiwen walo pi ma Nether",
  "item.minecraft.rabbit": "moku lete pi soweli lili",
  "item.minecraft.rabbit_foot": "noka pi soweli lili",
  "item.minecraft.rabbit_hide": "selo pi soweli lili",
  "item.minecraft.rabbit_spawn_egg": "sike mama pi soweli lili",
  "item.minecraft.rabbit_stew": "telo moku pi soweli lili",
  "item.minecraft.raiser_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "namako len sewi",
  "item.minecraft.ravager_spawn_egg": "sike mama pi monsuta suli",
  "item.minecraft.raw_copper": "kiwen ante lete",
  "item.minecraft.raw_gold": "kiwen jelo lete",
  "item.minecraft.raw_iron": "kiwen walo lete",
  "item.minecraft.recovery_compass": "ilo nasin moli",
  "item.minecraft.red_bundle": "poki len loje",
  "item.minecraft.red_dye": "kule loje",
  "item.minecraft.red_harness": "len sewi waso loje",
  "item.minecraft.redstone": "ko Redstone",
  "item.minecraft.resin_brick": "kiwen leko lili pi kiwen ko loje",
  "item.minecraft.resin_clump": "kiwen ko loje",
  "item.minecraft.rib_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.rib_armor_trim_smithing_template.new": "namako len palisa",
  "item.minecraft.rotten_flesh": "sijelo jaki",
  "item.minecraft.saddle": "len monsi soweli",
  "item.minecraft.salmon": "kala loje lete",
  "item.minecraft.salmon_bucket": "kala loje lon poki",
  "item.minecraft.salmon_spawn_egg": "sike mama pi kala loje",
  "item.minecraft.scrape_pottery_sherd": "kipisi poki selo",
  "item.minecraft.scute": "kiwen selo",
  "item.minecraft.sentry_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "namako len utala",
  "item.minecraft.shaper_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "namako len pali",
  "item.minecraft.sheaf_pottery_shard": "kipisi poki pan",
  "item.minecraft.sheaf_pottery_sherd": "kipisi poki pan",
  "item.minecraft.shears": "ilo kipisi lili",
  "item.minecraft.sheep_spawn_egg": "sike mama pi soweli len",
  "item.minecraft.shelter_pottery_shard": "kipisi poki kasi",
  "item.minecraft.shelter_pottery_sherd": "kipisi poki kasi",
  "item.minecraft.shield": "sinpin sijelo",
  "item.minecraft.shield.black": "sinpin sijelo pimeja",
  "item.minecraft.shield.blue": "sinpin sijelo pi laso telo",
  "item.minecraft.shield.brown": "sinpin sijelo pi loje ma",
  "item.minecraft.shield.cyan": "sinpin sijelo laso",
  "item.minecraft.shield.gray": "sinpin sijelo pi pimeja walo",
  "item.minecraft.shield.green": "sinpin sijelo pi laso kasi",
  "item.minecraft.shield.light_blue": "sinpin sijelo pi laso sewi",
  "item.minecraft.shield.light_gray": "sinpin sijelo pi walo pimeja",
  "item.minecraft.shield.lime": "sinpin sijelo pi laso jelo",
  "item.minecraft.shield.magenta": "sinpin sijelo pi loje laso",
  "item.minecraft.shield.orange": "sinpin sijelo pi loje jelo",
  "item.minecraft.shield.pink": "sinpin sijelo pi loje walo",
  "item.minecraft.shield.purple": "sinpin sijelo pi laso loje",
  "item.minecraft.shield.red": "sinpin sijelo loje",
  "item.minecraft.shield.white": "sinpin sijelo walo",
  "item.minecraft.shield.yellow": "sinpin sijelo jelo",
  "item.minecraft.shulker_shell": "selo pi monsuta Shulker",
  "item.minecraft.shulker_spawn_egg": "sike mama pi monsuta Shulker",
  "item.minecraft.sign": "lipu sitelen",
  "item.minecraft.silence_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.silence_armor_trim_smithing_template.new": "namako len pi kalama ala",
  "item.minecraft.silverfish_spawn_egg": "sike mama pi pipi kiwen",
  "item.minecraft.skeleton_horse_spawn_egg": "sike mama pi soweli tawa palisa",
  "item.minecraft.skeleton_spawn_egg": "sike mama pi jan moli palisa",
  "item.minecraft.skull_banner_pattern": "ilo sitelen pi lawa moli",
  "item.minecraft.skull_banner_pattern.desc": "sinpin pi jan moli palisa",
  "item.minecraft.skull_banner_pattern.new": "ilo sitelen pi lawa moli",
  "item.minecraft.skull_pottery_shard": "kipisi poki lawa",
  "item.minecraft.skull_pottery_sherd": "kipisi poki lawa",
  "item.minecraft.slime_ball": "ko monsuta",
  "item.minecraft.slime_spawn_egg": "sike mama pi monsuta ko",
  "item.minecraft.smithing_template": "lipu pi namako len",
  "item.minecraft.smithing_template.applies_to": "tawa:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "o pana e kiwen kule",
  "item.minecraft.smithing_template.armor_trim.applies_to": "len utala",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "o pana e len",
  "item.minecraft.smithing_template.armor_trim.ingredients": "kiwen kule",
  "item.minecraft.smithing_template.ingredients": "ijo pali:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "o pana e mani Netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ilo pi kiwen laso",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "o pana e ilo pi kiwen laso anu len pi kiwen laso",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "mani Netherite",
  "item.minecraft.smithing_template.upgrade": "namako: ",
  "item.minecraft.sniffer_spawn_egg": "sike mama pi soweli suli alasa",
  "item.minecraft.snort_pottery_shard": "kipisi poki akesi",
  "item.minecraft.snort_pottery_sherd": "kipisi poki akesi",
  "item.minecraft.snout_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.snout_armor_trim_smithing_template.new": "namako len soweli",
  "item.minecraft.snow_golem_spawn_egg": "sike mama pi jan pi ko lete",
  "item.minecraft.snowball": "sike ko lete",
  "item.minecraft.spectral_arrow": "palisa alasa suno",
  "item.minecraft.spider_eye": "oko pipi",
  "item.minecraft.spider_spawn_egg": "sike mama pi pipi noka",
  "item.minecraft.spire_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.spire_armor_trim_smithing_template.new": "namako len nena",
  "item.minecraft.splash_potion": "telo wawa pana",
  "item.minecraft.splash_potion.effect.awkward": "telo pana pi soko wawa",
  "item.minecraft.splash_potion.effect.empty": "telo pana pi ken ala pali",
  "item.minecraft.splash_potion.effect.fire_resistance": "telo pana pi awen lete",
  "item.minecraft.splash_potion.effect.harming": "telo pana pi ike sijelo",
  "item.minecraft.splash_potion.effect.healing": "telo pana pi pona sijelo",
  "item.minecraft.splash_potion.effect.infested": "telo pana pi kama pipi",
  "item.minecraft.splash_potion.effect.invisibility": "telo pana pi sijelo kon",
  "item.minecraft.splash_potion.effect.leaping": "telo pana pi noka suli",
  "item.minecraft.splash_potion.effect.levitation": "telo pana pi tawa sewi",
  "item.minecraft.splash_potion.effect.luck": "telo pana pi pona ken",
  "item.minecraft.splash_potion.effect.mundane": "telo pana pi wawa lili",
  "item.minecraft.splash_potion.effect.night_vision": "telo pana pi lukin wawa",
  "item.minecraft.splash_potion.effect.oozing": "telo pana pi pana ko",
  "item.minecraft.splash_potion.effect.poison": "telo pana pi ike sijelo kama",
  "item.minecraft.splash_potion.effect.regeneration": "telo pana pi pona sijelo awen",
  "item.minecraft.splash_potion.effect.slow_falling": "telo pana pi anpa ala",
  "item.minecraft.splash_potion.effect.slowness": "telo pana pi tawa ike",
  "item.minecraft.splash_potion.effect.strength": "telo pana pi utala wawa",
  "item.minecraft.splash_potion.effect.swiftness": "telo pana pi tawa wawa",
  "item.minecraft.splash_potion.effect.thick": "telo pana pi wawa lili",
  "item.minecraft.splash_potion.effect.turtle_master": "telo pana pi kama kiwen",
  "item.minecraft.splash_potion.effect.water": "telo pana",
  "item.minecraft.splash_potion.effect.water_breathing": "telo pana pi kon telo",
  "item.minecraft.splash_potion.effect.weakness": "telo pana pi utala ike",
  "item.minecraft.splash_potion.effect.weaving": "telo pana pi kama linja",
  "item.minecraft.splash_potion.effect.wind_charged": "telo pana pi pana kon",
  "item.minecraft.spruce_boat": "ilo tawa telo pi kasi lete",
  "item.minecraft.spruce_chest_boat": "poki lon ilo tawa telo pi kasi lete",
  "item.minecraft.spyglass": "palisa lukin",
  "item.minecraft.squid_spawn_egg": "sike mama pi kala luka",
  "item.minecraft.stick": "palisa",
  "item.minecraft.stone_axe": "ilo kipisi kiwen",
  "item.minecraft.stone_hoe": "ilo kasi kiwen",
  "item.minecraft.stone_pickaxe": "ilo pakala kiwen",
  "item.minecraft.stone_shovel": "ilo ma kiwen",
  "item.minecraft.stone_spear": "palisa utala tawa kiwen",
  "item.minecraft.stone_sword": "palisa utala kiwen",
  "item.minecraft.stray_spawn_egg": "sike mama pi jan moli lete",
  "item.minecraft.strider_spawn_egg": "sike mama pi akesi seli",
  "item.minecraft.string": "linja",
  "item.minecraft.sugar": "suwi kasi",
  "item.minecraft.suspicious_stew": "telo moku nasa",
  "item.minecraft.sweet_berries": "kili suwi",
  "item.minecraft.tadpole_bucket": "akesi sewi lili lon poki",
  "item.minecraft.tadpole_spawn_egg": "sike mama pi akesi sewi lili",
  "item.minecraft.tide_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.tide_armor_trim_smithing_template.new": "namako len kala",
  "item.minecraft.tipped_arrow": "palisa alasa wawa",
  "item.minecraft.tipped_arrow.effect.awkward": "palisa alasa pi wawa nasa",
  "item.minecraft.tipped_arrow.effect.empty": "palisa alasa wawa pi ken ala pali",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "palisa alasa pi awen lete",
  "item.minecraft.tipped_arrow.effect.harming": "palisa alasa pi ike sijelo",
  "item.minecraft.tipped_arrow.effect.healing": "palisa alasa pi pona sijelo",
  "item.minecraft.tipped_arrow.effect.infested": "palisa alasa pi kama pipi",
  "item.minecraft.tipped_arrow.effect.invisibility": "palisa alasa pi sijelo kon",
  "item.minecraft.tipped_arrow.effect.leaping": "palisa alasa pi noka wawa",
  "item.minecraft.tipped_arrow.effect.levitation": "palisa alasa pi tawa sewi",
  "item.minecraft.tipped_arrow.effect.luck": "palisa alasa pi ken pona",
  "item.minecraft.tipped_arrow.effect.mundane": "palisa alasa pi wawa lili",
  "item.minecraft.tipped_arrow.effect.night_vision": "palisa alasa pi lukin wawa",
  "item.minecraft.tipped_arrow.effect.oozing": "palisa alasa pi pana ko",
  "item.minecraft.tipped_arrow.effect.poison": "palisa alasa pi ike sijelo kama",
  "item.minecraft.tipped_arrow.effect.regeneration": "palisa alasa pi pona kama sijelo",
  "item.minecraft.tipped_arrow.effect.slow_falling": "palisa alasa pi anpa ala",
  "item.minecraft.tipped_arrow.effect.slowness": "palisa alasa pi tawa ike",
  "item.minecraft.tipped_arrow.effect.strength": "palisa alasa pi utala wawa",
  "item.minecraft.tipped_arrow.effect.swiftness": "palisa alasa pi tawa wawa",
  "item.minecraft.tipped_arrow.effect.thick": "palisa alasa pi wawa ala",
  "item.minecraft.tipped_arrow.effect.turtle_master": "palisa alasa pi kama kiwen",
  "item.minecraft.tipped_arrow.effect.water": "palisa alasa telo",
  "item.minecraft.tipped_arrow.effect.water_breathing": "palisa alasa pi kon telo",
  "item.minecraft.tipped_arrow.effect.weakness": "palisa alasa pi utala ike",
  "item.minecraft.tipped_arrow.effect.weaving": "palisa alasa pi kama linja",
  "item.minecraft.tipped_arrow.effect.wind_charged": "palisa alasa pi pana kon",
  "item.minecraft.tnt_minecart": " seli pakala lon poki tawa",
  "item.minecraft.torchflower_seeds": "sike mama pi kasi seli",
  "item.minecraft.totem_of_undying": "ilo pi moli ala",
  "item.minecraft.trader_llama_spawn_egg": "sike mama pi soweli pi jan esun",
  "item.minecraft.trial_key": "ilo open pi tomo alasa",
  "item.minecraft.trident": "ilo alasa telo",
  "item.minecraft.tropical_fish": "kala kule",
  "item.minecraft.tropical_fish_bucket": "kala kule lon poki",
  "item.minecraft.tropical_fish_spawn_egg": "sike mama pi kala kule",
  "item.minecraft.turtle_helmet": "selo akesi",
  "item.minecraft.turtle_scute": "kiwen selo tan akesi tomo",
  "item.minecraft.turtle_spawn_egg": "sike mama pi akesi tomo",
  "item.minecraft.vex_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.vex_armor_trim_smithing_template.new": "namako len kon",
  "item.minecraft.vex_spawn_egg": "sike mama pi kon ike",
  "item.minecraft.villager_spawn_egg": "sike mama pi jan tomo",
  "item.minecraft.vindicator_spawn_egg": "sike mama pi jan ike kipisi",
  "item.minecraft.wandering_trader_spawn_egg": "sike mama pi jan esun",
  "item.minecraft.ward_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.ward_armor_trim_smithing_template.new": "namako len awen",
  "item.minecraft.warden_spawn_egg": "sike mama pi monsuta kute",
  "item.minecraft.warped_fungus_on_a_stick": "soko lon palisa",
  "item.minecraft.water_bucket": "telo lon poki",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "namako len nasin",
  "item.minecraft.wheat": "kasi pan",
  "item.minecraft.wheat_seeds": "sike mama pan",
  "item.minecraft.white_bundle": "poki len walo",
  "item.minecraft.white_dye": "kule walo",
  "item.minecraft.white_harness": "len sewi waso walo",
  "item.minecraft.wild_armor_trim_smithing_template": "lipu pi namako len",
  "item.minecraft.wild_armor_trim_smithing_template.new": "namako len kasi",
  "item.minecraft.wind_charge": "sike kon",
  "item.minecraft.witch_spawn_egg": "sike mama pi jan pi telo wawa",
  "item.minecraft.wither_skeleton_spawn_egg": "sike mama pi jan moli palisa Wither",
  "item.minecraft.wither_spawn_egg": "sike mama pi monsuta Wither",
  "item.minecraft.wolf_armor": "len pi soweli pona",
  "item.minecraft.wolf_spawn_egg": "sike mama pi soweli pona",
  "item.minecraft.wooden_axe": "ilo kipisi kasi",
  "item.minecraft.wooden_hoe": "ilo kasi tan kasi",
  "item.minecraft.wooden_pickaxe": "ilo pakala kasi",
  "item.minecraft.wooden_shovel": "ilo ma kasi",
  "item.minecraft.wooden_spear": "palisa utala tawa kasi",
  "item.minecraft.wooden_sword": "palisa utala kasi",
  "item.minecraft.writable_book": "lipu en ilo sitelen",
  "item.minecraft.written_book": "lipu sitelen",
  "item.minecraft.yellow_bundle": "poki len jelo",
  "item.minecraft.yellow_dye": "kule jelo",
  "item.minecraft.yellow_harness": "len sewi waso jelo",
  "item.minecraft.zoglin_spawn_egg": "sike mama pi soweli moli Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "sike mama pi soweli tawa moli",
  "item.minecraft.zombie_nautilus_spawn_egg": "sike mama pi kala sike moli",
  "item.minecraft.zombie_spawn_egg": "sike mama pi jan moli",
  "item.minecraft.zombie_villager_spawn_egg": "sike mama pi jan tomo moli",
  "item.minecraft.zombified_piglin_spawn_egg": "sike mama pi jan Piglin moli"
}
export const tok = items; 
